import React, {Component} from 'react';
import Lottie from 'react-lottie';

import fondoCarta from '../../Assets/Images/WallpaperCarta.jpg';
import fondoCoverLeft from '../../Assets/Images/WallpaperCoverLeft.jpg';
import fondoCoverRight from '../../Assets/Images/WallpaperCoverRight.jpg';

import mosaicBackground from '../../Assets/Images/MosaicFondo.jpg';
import mosaicBackgroundDark from '../../Assets/Images/MosaicFondoOscuro.jpg';

import textoTwistLeft from '../../Assets/Images/TextoTwistLeft.png' ;
import textoTwistRight from '../../Assets/Images/TextoTwistRight.png';
import topCartaLeft from '../../Assets/Images/TopCartaLeft.png' ;
import topCartaRight from '../../Assets/Images/TopCartaRight.png';
import stepsVertical from '../../Assets/Images/StepsVertical.png' ;
import stepsHorizontal from '../../Assets/Images/StepsHorizontal.png' ;

import logoTwist from '../../Assets/Images/TwistLogoNew.png' ;
import logoPremio from '../../Assets/Images/LogoPremio.png' ;
import anden from '../../Assets/Images/Anden.png' ;

import simpsonsTabla from '../../Assets/Images/TablaSimpsons.png' ;
import simpsonsChupito from '../../Assets/Images/ChupitosSimpsons.png' ;
import simpsonsBebidas from '../../Assets/Images/BebidasSimpsons.png' ;
import simpsonsSnacks from '../../Assets/Images/SnacksSimpsons.png' ;

import idiomaEsp from '../../Assets/Images/IdiomaEsp.png';
import idiomaEng from '../../Assets/Images/IdiomaEng.png';
import languageIcon from '../../Assets/Images/CambioIdiomaIcono.png';
import vegan from '../../Assets/Images/Vegan.png';
import chupitosIndividualesTabla from '../../Assets/Images/ChupitosIndividuales.png';
import chupitosComplemento from '../../Assets/Images/ChupitosComplemento.png';
//import chupitosComplemento2 from '../../Assets/Images/ChupitosComplemento2.png';
import bebidas from '../../Assets/Images/Bebidas.png';
import snacks from '../../Assets/Images/Snacks.png';
import snackDulce from '../../Assets/Images/SnackDulce.png';
import snackSalado from '../../Assets/Images/SnackSalado.png';


import suaves from '../../Assets/Images/Suaves.png';
import fuertes from '../../Assets/Images/Fuertes.png';
import flipas from '../../Assets/Images/Flipas.png';
import especiales from '../../Assets/Images/Especiales.png';
import temporada from '../../Assets/Images/Temporada.png';
import fuego from '../../Assets/Images/Fuego.png';
import picante from '../../Assets/Images/Picante.png';
import animationFuego from "../../Assets/Animations/AnimationFuego.json";

import navidadTabla from '../../Assets/Images/NavidadTabla.png';
import hogwartsTabla from '../../Assets/Images/HogwartsTabla.png';
import pokemonTabla from '../../Assets/Images/PokemonTabla.png';
import calamarTabla from '../../Assets/Images/CalamarTabla.png';
import amongUs1 from '../../Assets/Images/AmongUs1.png';
import amongUs2 from '../../Assets/Images/AmongUs2.png';
import amongUs3 from '../../Assets/Images/AmongUs3.png';
import amongUs4 from '../../Assets/Images/AmongUs4.png';
import avengersTabla from '../../Assets/Images/AvengersTabla.png';
import aventurasTabla from '../../Assets/Images/AventurasTabla.png';
import toyStoryTabla from '../../Assets/Images/ToyStoryTabla.PNG';
import insideOutTabla from '../../Assets/Images/InsideOutTabla.png';
import insideOutTabla2 from '../../Assets/Images/InsideOutTabla2.png'
import insideOutTabla3 from '../../Assets/Images/InsideOutTabla3.png'
import pocionesTabla from '../../Assets/Images/PocionesTabla.png';
import powerRangersTabla from '../../Assets/Images/PowerRangersTabla.png';
import mezclaPowerRangers from '../../Assets/Images/MezclaPowerRangers.png';
import rockyHorrorTabla from '../../Assets/Images/RockyHorrorTabla.png';
import mezclaRockyHorror from '../../Assets/Images/RockyHorrorMezcla.png';
import disneyTabla from '../../Assets/Images/DisneyTabla.png';
import rockStarTabla from '../../Assets/Images/RockStarTabla.png';
import tronosTabla from '../../Assets/Images/TronosTabla.png';

import chupitosSuaves from '../../Assets/Images/ChupitosSuaves.png';
import chupitosFuertes from '../../Assets/Images/ChupitosFuertes.png';
import chupitosFlipas from '../../Assets/Images/ChupitosFlipas.png';
import chupitosEspeciales from '../../Assets/Images/ChupitosEspeciales.png';
import chupitosTemporada from '../../Assets/Images/ChupitosTemporada.png';

import cocktailIcono from '../../Assets/Images/CocktailIcono.png';
import cervezaIcono from '../../Assets/Images/CervezaIcono.png';
import palmeraIcono from '../../Assets/Images/palmera.png';
import refrescosIcono from '../../Assets/Images/RefrescosIcono.png';
import vinosIcono from '../../Assets/Images/VinosIcono.png';
import batidoIcono from '../../Assets/Images/BatidoIcono.png';
import copasIcono from '../../Assets/Images/CopasIcono.png';
import extrasIcono from '../../Assets/Images/ExtrasIcono.png';

import tropicales from '../../Assets/Images/TropicalesCocktails.png';
import tropicalesPrem from '../../Assets/Images/TropPremiumCocktails.png';
import clasicos from '../../Assets/Images/ClasicosCocktails.png';
import clasicosPremium from '../../Assets/Images/ClasPremiumCocktails.png';
import sinAlcohol from '../../Assets/Images/SinAlcoholCocktails.png';


import './Carta.css';

import Zoom from 'react-reveal/Zoom';
import Fade from 'react-reveal/Fade';
import Bounce from 'react-reveal/Bounce';

var leftPositionValue = 0

class Carta extends Component{


    constructor(props) {
        super(props);
        this.state = {
            horizontal: false,
            horizontalIndice: false,
            tablaHogwartsState : false,
            tablaPokemonState : false,
            tablaCalamarState : false,
            tablaAvengersState : false,
            tablaToyStoryState : false,
            tablaAventurasState : false,
            tablaNavidadState : false,
            tablaInsideOut : false,
            tablaPocionesState : false,
            tablaRangersState : false,
            tablaRockyState : false,
            tablaDisneyState : false,
            tablaRockStarState : false,
            tablaTronosState : false,
            chupitosSuavesState : false,
            chupitosFuertesState : false,
            chupitosFlipasState : false,
            chupitosEspecialesState : false,
            chupitosTemporadaState : false,
            cocktailsTropicales: false,
            cocktailsTropicalesPremium: false,
            cocktailsClasicos: false,
            cocktailsClasicosPremium: false,
            cocktailsSinAlcohol: false,
            theposition : 0,
            renderCarta : false,
            renderIndice : false,
            venganFilter : false,
            languageEnglish : false
        }
        
    }

    componentDidMount() {
        window.addEventListener('scroll', this.listenToScroll)
        setTimeout(() => {
            this.setState({renderCarta : true})
        }, 2200);

        var width = window.innerWidth
        
        if(width>500){
            this.setState({horizontal : true})
            this.setState({horizontalIndice : true})
        }
    }

    listenToScroll = () => {
        const winScroll =
          document.body.scrollTop || document.documentElement.scrollTop
      
        const height =
          document.documentElement.scrollHeight -
          document.documentElement.clientHeight
      
        const scrolled = winScroll / height
      
        this.setState({
          theposition: scrolled,
        })

        console.log("Position Scroll", this.state.theposition)
        if(this.state.renderIndice){
            this.setState({renderIndice : false})
        }
        
        if(this.state.theposition<=0.08 && this.state.renderIndice){
            this.setState({renderIndice : false})
        }
    }

    changeIndiceValue(value){
        var width = window.innerWidth
        
        if(width>500){
            this.setState({horizontalIndice : true})
        }else{
            this.setState({horizontalIndice : false})
        }
        this.setState({renderIndice : value})
        console.log("Volver indice", this.state.renderIndice)
    }

    changeVeganFilter(){
        this.setState({venganFilter : !this.state.venganFilter})
    }

    changeLanguage(){
        this.setState({languageEnglish : !this.state.languageEnglish})
    }

    renderChupitosTablas(tabla){
        console.log("Render Hogwarts", this.state.tablaHogwartsState)
        if(tabla=="Hogwarts"){
            if(this.state.tablaHogwartsState){
                this.setState({tablaHogwartsState : false})
            }else{
                this.setState({tablaHogwartsState : true})
            }
        }

        if(tabla=="Pokemon"){
            if(this.state.tablaPokemonState){
                this.setState({tablaPokemonState : false})
            }else{
                this.setState({tablaPokemonState : true})
            }
        }

        if(tabla=="Calamar"){
            if(this.state.tablaCalamarState){
                this.setState({tablaCalamarState : false})
            }else{
                this.setState({tablaCalamarState : true})
            }
        }
        if(tabla=="Avengers"){
            if(this.state.tablaAvengersState){
                this.setState({tablaAvengersState : false})
            }else{
                this.setState({tablaAvengersState : true})
            }
        }

        if(tabla=="Aventuras"){
            if(this.state.tablaAventurasState){
                this.setState({tablaAventurasState : false})
            }else{
                this.setState({tablaAventurasState : true})
            }
        }

        if(tabla=="ToyStory"){
            if(this.state.tablaToyStoryState){
                this.setState({tablaToyStoryState : false})
            }else{
                this.setState({tablaToyStoryState : true})
            }
        }

        if(tabla=="Inside Out"){
            if(this.state.tablaInsideOut){
                this.setState({tablaInsideOut : false})
            }else{
                this.setState({tablaInsideOut : true})
            }
        }

        if(tabla=="Pociones"){
            if(this.state.tablaPocionesState){
                this.setState({tablaPocionesState : false})
            }else{
                this.setState({tablaPocionesState : true})
            }
        }

        if(tabla=="Navidad"){
            if(this.state.tablaNavidadState){
                this.setState({tablaNavidadState : false})
            }else{
                this.setState({tablaNavidadState : true})
            }
        }

        if(tabla=="Rangers"){
            if(this.state.tablaRangersState){
                this.setState({tablaRangersState : false})
            }else{
                this.setState({tablaRangersState : true})
            }
        }

        if(tabla=="Rocky"){
            if(this.state.tablaRockyState){
                this.setState({tablaRockyState : false})
            }else{
                this.setState({tablaRockyState : true})
            }
        }

        if(tabla=="Disney"){
            if(this.state.tablaDisneyState){
                this.setState({tablaDisneyState : false})
            }else{
                this.setState({tablaDisneyState : true})
            }
        }

        if(tabla=="RockStar"){
            if(this.state.tablaRockStarState){
                this.setState({tablaRockStarState : false})
            }else{
                this.setState({tablaRockStarState : true})
            }
        }

        if(tabla=="Tronos"){
            if(this.state.tablaTronosState){
                this.setState({tablaTronosState : false})
            }else{
                this.setState({tablaTronosState : true})
            }
        }
    }

    renderChupitosIndividuales(tipo){
        console.log("Render Hogwarts", this.state.tablaHogwartsState)
        if(tipo=="Suaves"){
            if(this.state.chupitosSuavesState){
                this.setState({chupitosSuavesState : false})
            }else{
                this.setState({chupitosSuavesState : true})
            }
        }
        if(tipo=="Fuertes"){
            if(this.state.chupitosFuertesState){
                this.setState({chupitosFuertesState : false})
            }else{
                this.setState({chupitosFuertesState : true})
            }
        }

        if(tipo=="Flipas"){
            if(this.state.chupitosFlipasState){
                this.setState({chupitosFlipasState : false})
            }else{
                this.setState({chupitosFlipasState : true})
            }
        }

        if(tipo=="Especiales"){
            if(this.state.chupitosEspecialesState){
                this.setState({chupitosEspecialesState : false})
            }else{
                this.setState({chupitosEspecialesState : true})
            }
        }

        if(tipo=="Temporada"){
            if(this.state.chupitosTemporadaState){
                this.setState({chupitosTemporadaState : false})
            }else{
                this.setState({chupitosTemporadaState : true})
            }
        }
    }

    renderCocktails(tipo){
        console.log("Render Hogwarts", this.state.tablaHogwartsState)
        if(tipo=="tropicales"){
            if(this.state.cocktailsTropicales){
                this.setState({cocktailsTropicales : false})
            }else{
                this.setState({cocktailsTropicales : true})
            }
        }
        if(tipo=="tropicalesPremium"){
            if(this.state.cocktailsTropicalesPremium){
                this.setState({cocktailsTropicalesPremium : false})
            }else{
                this.setState({cocktailsTropicalesPremium : true})
            }
        }

        if(tipo=="clasicos"){
            if(this.state.cocktailsClasicos){
                this.setState({cocktailsClasicos : false})
            }else{
                this.setState({cocktailsClasicos : true})
            }
        }

        if(tipo=="clasicosPremium"){
            if(this.state.cocktailsClasicosPremium){
                this.setState({cocktailsClasicosPremium : false})
            }else{
                this.setState({cocktailsClasicosPremium : true})
            }
        }

        if(tipo=="sinAlcohol"){
            if(this.state.cocktailsSinAlcohol){
                this.setState({cocktailsSinAlcohol : false})
            }else{
                this.setState({cocktailsSinAlcohol : true})
            }
        }
    }

    renderCover(){
        if(this.state.horizontal){
            return(
            <div id="inicio" className="Carta" style={{display: 'flex', position: 'absolute', width: '100%', height: 'auto', overflow: 'hidden'}}>
                    {this.renderCarta()}
            </div>
            )
        }else{
            return(
                <div id="inicio" className="Carta" style={{display: 'flex', position: 'absolute', width: '100%', height: this.state.renderCarta ? 'auto' : '100%', overflow: 'hidden'}}>
                    
                    <div className='leftCover' style={{display: 'flex', position: 'absolute', top: 0, left: 0, width: '50%', height: '100%', alignItems: 'center', justifyContent: 'right', backgroundImage: `url(${fondoCoverLeft})`, backgroundColor: 'white', opacity: 1, zIndex: 200}}>
                    <div style={{position: 'relative', width: '100%', height: '100%', }}>
                            <div style={{width: '100%', height: 50}}></div>
                            <img src={topCartaLeft} style={{width: '100%'}} alt="Top"/>
                            <img src={textoTwistLeft} style={{width: '100%'}} alt="Twist"/>
        
                    </div>      
                    </div> 
                    <div className='rightCover' style={{position: 'absolute', top: 0, right: 0, width: '50%', height: '100%', alignItems: 'center', justifyContent: 'left', backgroundImage: `url(${fondoCoverRight})`, backgroundColor: 'white', opacity: 1, zIndex: 200}}>
                    <img src={stepsHorizontal} style={{position: 'absolute', top: 300, left: 0, maxWidth: 150, opacity: 0.8}} alt="Top"/>
                    
                    <div style={{position: 'relative', width: '100%', height: '100%' }}>
                            <div style={{width: '100%', height: 50}}></div>
                            <img src={topCartaRight} style={{width: '100%', }} alt="Top"/>
                            <img src={textoTwistRight} style={{width: '100%', }} alt="Twist"/>
                    </div>
                    </div>
                    
                    {this.renderCarta()}
                </div>
                )
        }
        
    }


    renderIndice(){
        return(
            <div style={{display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', marginTop: 40, marginBottom: 0}}>
            <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                
                <div style={{display: 'flex', flexDirection: 'column', width: '50%'}}>
                <a href="#tablasChupitos" style={{textDecoration: 'none'}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Zoom>
                <img src={simpsonsTabla} style={{height: 120, opacity: 1}} alt="Top"/>
                </Zoom>
                <Fade left>
                <p className='style10Font' style={{color: 'black', fontSize: 30, marginTop: 0, whiteSpace: 'pre-wrap'}}>{this.state.languageEnglish ? 'Shot \ncombos' : 'Tablas de \nchupitos'}</p>
                </Fade>
                </div>
                </a>
                <a href="#chupitos" style={{textDecoration: 'none'}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Zoom>
                <img src={simpsonsChupito} style={{height: 120}} alt="Top"/>
                </Zoom>
                <Fade left>
                <p className='style10Font' style={{color: 'black', fontSize: 30, textAlign: 'center', marginTop: 0}}>{this.state.languageEnglish ? 'Shots' : 'Chupitos'}</p>
                </Fade>
                </div>
                </a>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', width: '50%'}}>
                <a href="#bebidas" style={{textDecoration: 'none'}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Zoom>
                <img src={simpsonsBebidas} style={{height: 120}} alt="Top"/>
                </Zoom>
                <Fade right>
                <p className='style10Font' style={{color: 'black', fontSize: 30, textAlign: 'center', marginTop: 0, whiteSpace: 'pre-wrap'}}>{this.state.languageEnglish ? 'Cocktails & \nDrinks' : 'Cocktails y \nBebidas'}</p>
                </Fade>
                </div>
                </a>
                <a href="#snacks" style={{textDecoration: 'none'}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Zoom>
                <img src={simpsonsSnacks} style={{height: 120}} alt="Top"/>
                </Zoom>
                <Fade right>
                <p className='style10Font' style={{color: 'black', fontSize: 30, textAlign: 'center', marginTop: 0}}>Snacks</p>
                </Fade>
                </div>
                </a>
                </div>
                </div>
                <div style={{width: '90%', height: 2, backgroundColor: '#CF1009'}}></div>

                <button onClick={()=>{this.changeLanguage()}} style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                    <Fade left>
                    {this.state.languageEnglish
                    ?
                    <img src={idiomaEsp} style={{width: 30, marginRight: 20}} alt="Top"/>
                    :
                    <img src={idiomaEng} style={{width: 30, marginRight: 20}} alt="Top"/>
                    }
                    </Fade> 
                    <Zoom>
                    {this.state.languageEnglish
                    ?
                    <p className='style10Font' style={{textAlign: 'center', fontSize: 28, color: 'black', marginRight: 20}}>{'CAMBIAR A ESPAÑOL'}</p>
                    :
                    <p className='style10Font' style={{textAlign: 'center', fontSize: 28, color: 'black', marginRight: 20}}>{'SWITCH TO ENGLISH'}</p>
                    }
                    </Zoom>
                    <Fade right>
                   
                    
                    <img src={languageIcon} style={{width: 25, marginRight: 20}} alt="Top"/>
                    
                    
                    </Fade>
                </button>
                <div style={{width: '80%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>
                
                <button onClick={()=>this.changeVeganFilter()} style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                    <Fade left>
                    <img src={vegan} style={{width: 30, marginRight: 20}} alt="Top"/>
                    </Fade>
                    <Zoom>
                    <p className='style10Font' style={{textAlign: 'center', fontSize: 28, color: 'black', marginRight: 20}}>{this.state.languageEnglish ? 'VEGAN FILTER' : 'FILTRO VEGANO'}</p>
                    </Zoom>
                    <Fade right>
                    <div style={{display: 'flex', width: 60, height: 25, backgroundColor: this.state.venganFilter ? 'green' : '#b00d07', borderRadius: 20, borderStyle: 'solid', borderWidth: 2, borderColor: 'black', alignItems: 'center', justifyContent: 'space-around'}}>
                    {this.state.venganFilter
                    ?
                    <p className='style5Font' style={{fontSize: 12, color: 'white'}}>ON</p>
                    :
                    <p className='style5Font' style={{fontSize: 12, color: 'white'}}>OFF</p>
                    }
                    </div>
                    </Fade>
                </button>
                {/*
                <Zoom>
                
                <a href="https://es.restaurantguru.com/Twist-and-Shout-Bar-Madrid">

                    
                    <img src={logoPremio} style={{width: 150, marginTop: 10, marginBottom: 20}} alt="Top"/>
                </a>
                </Zoom>
                */}
                <div style={{width: '90%', height: 2, backgroundColor: '#CF1009'}}></div>
                </div>
        )
    }

    renderIndiceDesplegable(){
        return(
            <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', marginTop: 20}}>
                
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                
                <div style={{display: 'flex', flexDirection: 'column', width: '50%'}}>
                <a href="#tablasChupitos" onClick={()=>this.changeIndiceValue(false)} style={{textDecoration: 'none'}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Zoom>
                <img src={simpsonsTabla} style={{height: 100}} alt="Top"/>
                </Zoom>
                <Fade left>
                <p className='style10Font' style={{color: 'white', fontSize: 25, marginTop: 0, whiteSpace: 'pre-wrap'}}>{this.state.languageEnglish ? 'Shot \ncombos' : 'Tablas de \nchupitos'}</p>
                </Fade>
                </div>
                </a>
                <a href="#chupitos" onClick={()=>this.changeIndiceValue(false)} style={{textDecoration: 'none'}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Zoom>
                <img src={simpsonsChupito} style={{height: 100}} alt="Top"/>
                </Zoom>
                <Fade left>
                <p className='style10Font' style={{color: 'white', fontSize: 25, textAlign: 'center', marginTop: 0}}>{this.state.languageEnglish ? 'Shots' : 'Chupitos'}</p>
                </Fade>
                </div>
                </a>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', width: '50%'}}>
                <a href="#bebidas" onClick={()=>this.changeIndiceValue(false)} style={{textDecoration: 'none'}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Zoom>
                <img src={simpsonsBebidas} style={{height: 100}} alt="Top"/>
                </Zoom>
                <Fade right>
                <p className='style10Font' style={{color: 'white', fontSize: 25, textAlign: 'center', marginTop: 0, whiteSpace: 'pre-wrap'}}>{this.state.languageEnglish ? 'Cocktails & \nDrinks' : 'Cocktails y \nBebidas'}</p>
                </Fade>
                </div>
                </a>
                <a href="#snacks" onClick={()=>this.changeIndiceValue(false)} style={{textDecoration: 'none'}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Zoom>
                <img src={simpsonsSnacks} style={{height: 100}} alt="Top"/>
                </Zoom>
                <Fade right>
                <p className='style10Font' style={{color: 'white', fontSize: 25, textAlign: 'center', marginTop: 0}}>Snacks</p>
                </Fade>
                </div>
                </a>
                </div>
                </div>
                </div>
        )
    }

    renderIndiceDesplegableHorizontal(){
        return(
            <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', marginTop: 20}}>
                
                <div style={{display: 'flex', width: '100%', justifyContent: 'space-around'}}>
                
                <a href="#tablasChupitos" onClick={()=>this.changeIndiceValue(false)} style={{textDecoration: 'none'}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Zoom>
                <img src={simpsonsTabla} style={{height: 70}} alt="Top"/>
                </Zoom>
                <Fade left>
                <p className='style10Font' style={{color: 'white', fontSize: 20, marginTop: 0, whiteSpace: 'pre-wrap'}}>{this.state.languageEnglish ? 'Shot \ncombos' : 'Tablas de \nchupitos'}</p>
                </Fade>
                </div>
                </a>
                <a href="#chupitos" onClick={()=>this.changeIndiceValue(false)} style={{textDecoration: 'none'}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Zoom>
                <img src={simpsonsChupito} style={{height: 70}} alt="Top"/>
                </Zoom>
                <Fade left>
                <p className='style10Font' style={{color: 'white', fontSize: 20, textAlign: 'center', marginTop: 0}}>{this.state.languageEnglish ? 'Shots' : 'Chupitos'}</p>
                </Fade>
                </div>
                </a>
                <a href="#bebidas" onClick={()=>this.changeIndiceValue(false)} style={{textDecoration: 'none'}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Zoom>
                <img src={simpsonsBebidas} style={{height: 70}} alt="Top"/>
                </Zoom>
                <Fade right>
                <p className='style10Font' style={{color: 'white', fontSize: 20, textAlign: 'center', marginTop: 0, whiteSpace: 'pre-wrap'}}>{this.state.languageEnglish ? 'Cocktails & \nDrinks' : 'Cocktails y \nBebidas'}</p>
                </Fade>
                </div>
                </a>
                <a href="#snacks" onClick={()=>this.changeIndiceValue(false)} style={{textDecoration: 'none'}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Zoom>
                <img src={simpsonsSnacks} style={{height: 70}} alt="Top"/>
                </Zoom>
                <Fade right>
                <p className='style10Font' style={{color: 'white', fontSize: 20, textAlign: 'center', marginTop: 0}}>Snacks</p>
                </Fade>
                </div>
                </a>
                </div>
                </div>
        )
    }

    renderCarta(){
        return(
            <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column', width: '100%', borderStyle: 'solid', borderWidth: 10, borderTopWidth:0, borderBottomWidth:0, borderColor: '#b00d07', backgroundImage: `url(${mosaicBackground})`, paddingBottom: 50 }}>

                {this.state.theposition>0.08
                ?
                <Fade bottom>
                <div style={{position: 'fixed', bottom: -2, width: '100%', backgroundColor: '#610000', borderTopLeftRadius: 20, borderTopRightRadius: 20, zIndex: 100}}>
                    
                    {this.state.renderIndice
                    ?
                    <button onClick={()=>this.changeIndiceValue(false)} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none', zIndex: 100}}>
                    <p className='style10Font' style={{textAlign: 'center', fontSize: 20, color: 'white'}}>{this.state.languageEnglish ? 'PRESS HERE TO CLOSE' : 'PULSA AQUÍ PARA CERRAR'}</p>
                    </button>
                    :
                    <button onClick={()=>this.changeIndiceValue(true)} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none', zIndex: 100}}>
                    <p className='style10Font' style={{textAlign: 'center', fontSize: 20, color: 'white'}}>{this.state.languageEnglish ? 'PRESS TO OPEN MENU' : 'PULSA PARA VER EL ÍNDICE'}</p>
                    </button>
                    }
                    {this.state.renderIndice
                    ?
                    <div style={{width: '100%'}}>
                        {this.state.horizontalIndice
                        ?
                        this.renderIndiceDesplegableHorizontal()
                        :
                        this.renderIndiceDesplegable()
                        }
                    </div>
                    :
                    null
                    }
                </div>
                </Fade>
                :
                null
                }
                <div style={{display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', justifyContent: 'space-around'}}>

                <Zoom>
                <img src={logoTwist} style={{width: '80%', maxWidth: 350, marginTop: 40, marginBottom: 20}} alt="Top"/>
                </Zoom>
               


                
                </div>
                <div>
                </div>

                {/*----Menu----*/}

                
                {this.renderIndice()}
               

                {/*------------*/}

                {this.renderSummer()}

                {this.renderTablas()}

                {/*------------*/}

                {this.renderChupitos()}

                {this.renderBebidas()}

                {this.renderSnacks()}

            
            </div>
        )
    }

    renderSummer(){
        return(
            <div id="tablasChupitos" style={{display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', marginTop: 20, marginBottom: 20}}>
                <Fade bottom>
                <p className='style10Font' style={{fontSize: 40, color: '#136d26', textAlign: 'center', marginBottom: 30}}>{this.state.languageEnglish ? 'Summer Special' : 'Especial Verano'}</p>
                </Fade>

                <Fade bottom>
                <div style={{display: 'flex', flexDirection: 'column', width: '90%', alignItems: 'center', justifyContent: 'center'}}>
                <img src={palmeraIcono} style={{width: '30%', maxWidth: 100}} alt="Top"/>
                <p className='style9Font' style={{fontSize: 22, fontWeight: 'bold', color: 'black', textAlign: 'center', marginTop: 10}}>{this.state.languageEnglish ? 'This summer, cool off with our tropical beers' : 'Este verano refrescaté con nuestras cervezas tropicales'}</p>
                </div>
                </Fade>

                <div style={{width: '90%'}}>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'BirraColau Small' : 'BirraColau Caña'}</p>
                    </div>
                    
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'DaiBirri Small' : 'DaiBirri Caña'}</p>
                    </div>
                    
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'BirraColau Jar' : 'BirraColau Jarra'}</p>
                    </div>
                    
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>6,5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'DaiBirri Jar' : 'DaiBirri Jarra'}</p>
                    </div>
                    
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>6,5 €</p>
                    </div>
                    </Zoom>
                    </div>
                </div>
        )
    }

    renderTablas(){
        return(
            <div id="tablasChupitos" style={{display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', marginTop: 20, marginBottom: 20}}>
                <Fade bottom>
                <p className='style10Font' style={{fontSize: 40, color: '#b00d07', textAlign: 'center', marginBottom: 30}}>{this.state.languageEnglish ? 'Shot Combos' : 'Tablas de chupitos'}</p>
                </Fade>

                <Fade bottom>
                <div style={{display: 'flex', flexDirection: 'column', width: '90%', alignItems: 'center', justifyContent: 'center'}}>
                <img src={chupitosIndividualesTabla} style={{width: '30%', maxWidth: 100}} alt="Top"/>
                <p className='style9Font' style={{fontSize: 22, fontWeight: 'bold', color: 'black', textAlign: 'center', marginTop: 10}}>{this.state.languageEnglish ? 'May we remind you can order each shot individually for' : 'Recordad que podreis pedir los chupitos de las tablas sueltos por'} <span style={{fontSize: 28, fontWeight: 'bold'}}>3€ </span></p>
                </div>
                </Fade>

                <Zoom>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <div style={{display: 'flex', alignItems: 'center', margin: 5}}>
                <img src={suaves} style={{height: 25, marginRight: 4, marginBottom: 2}} alt="Top"/>
                <p className='style5Font' style={{fontSize: 16, color: '#5AA862'}}>{this.state.languageEnglish ? 'Light' : 'Suaves'}</p>
                </div>
                <div style={{display: 'flex', alignItems: 'center', margin: 5}}>
                <img src={fuertes} style={{height: 25, marginRight: 4, marginBottom: 2}} alt="Top"/>
                <p className='style5Font' style={{fontSize: 16, color: '#D0954D'}}>{this.state.languageEnglish ? 'Strong' : 'Fuertes'}</p>
                </div>

                <div style={{display: 'flex', alignItems: 'center', margin: 5}}>
                <img src={flipas} style={{height: 25, marginRight: 4, marginBottom: 2}} alt="Top"/>
                <p className='style5Font' style={{fontSize: 16, color: '#B0256E'}}>{this.state.languageEnglish ? 'Wow' : 'Flipas'}</p>
                </div>
                </div>

                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-around', marginTop: -20, marginBottom: 20}}>
                <div style={{display: 'flex', alignItems: 'center', margin: 5}}>
                <img src={fuego} style={{height: 25, marginRight: 4, marginBottom: 2}} alt="Top"/>
                <p className='style5Font' style={{fontSize: 16, color: '#605ED2'}}>{this.state.languageEnglish ? 'Fire' : 'Fuego'}</p>
                </div>
                <div style={{display: 'flex', alignItems: 'center', margin: 5}}>
                <img src={picante} style={{height: 25, marginRight: 4, marginBottom: 2}} alt="Top"/>
                <p className='style5Font' style={{fontSize: 16, color: '#CF1009'}}>{this.state.languageEnglish ? 'Spicy' : 'Picante'}</p>
                </div>
                </div>
                </Zoom>


                {/*HOGWARTS*/}


                <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>
                
                <button onClick={()=>{this.renderChupitosTablas("Hogwarts")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                <Zoom>
                <img src={hogwartsTabla} style={{width: '60%', maxWidth: 300}} alt="Top"/>
                <div style={{marginTop: 20}}>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 50, textAlign: 'center', marginBottom: -30, marginTop: 0}}>9 €</p>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 22, textAlign: 'center'}}>{this.state.languageEnglish ? '4 shots' : '4 chupitos'}</p>
                </div>
                </Zoom>
                </div>
                </button>

                {this.state.tablaHogwartsState
                ?
                <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                <Bounce left>
                <div style={{}}>
                    <p className='style5Font' style={{color: '#ae0001', fontSize: 20}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>GRYFFINDOR: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Licor 43 + Grenadine + Vodka' : 'Licor 43 + Granadina + Vodka'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#2a623d', fontSize: 20}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>SLYTHERIN: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Kiwi + Black Absinthe' : 'Kiwi + Absenta Negra'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#ecb939', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>HUFFLEPUFF: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Banana Liqueur + Black Vodka' : 'Licor de Plátano + Vodka Negro'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#425cb3', fontSize: 20}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>RAVENCLAW: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Blue Curaçao + Black Vodka' : 'Curaçao Azul + Vodka Negro'}</span></p>
                </div>
                </Bounce>
                </div>
                :
                null
                }

                {/*POKEMON

                
                <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>
                
                <button onClick={()=>{this.renderChupitosTablas("Pokemon")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                <Zoom>
                <img src={pokemonTabla} style={{width: '60%', maxWidth: 300}} alt="Top"/>
                <div style={{marginTop: 20}}>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 50, textAlign: 'center', marginBottom: -30, marginTop: 0}}>9 €</p>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 22, textAlign: 'center'}}>{this.state.languageEnglish ? '4 shots' : '4 chupitos'}</p>
                </div>
                </Zoom>
                </div>
                </button>

                {this.state.tablaPokemonState
                ?
                <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                <Bounce left>
                <div style={{}}>
                    <p className='style5Font' style={{color: '#4bda2b', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>BULBASAUR: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? '43 Liqueur + Vodka + Kiwi + Granadine + Peppermint' : 'Licor 43 + Vodka + Granadina + Kiwi + Hierbabuena'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#e9741c', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>CHARMANDER: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Mango + Martini Rosso + ThunderBitch + Red Absenth' : 'Mango + Martini Rosso + ThunderBitch + Absenta Roja'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#1cd1e9', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>SQUIRTLE: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'White Rum + Limoncello + Blue Tropic + Orange Sugar' : 'Ron Blanco + Limoncello + Blue Tropic + Caparazón de Azúcar Naranja'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#e9e21c', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>PIKACHU: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Bourbon + Pineapple + White Wine + Black Vodka + Peta-Zetas' : 'Bourbon + Piña + Vino Blanco + Vodka Negro + Peta-Zetas'}</span></p>
                </div>
                </Bounce>
                </div>
                :
                null
                }
                */}


                {/*JUEGO DEL CALAMAR*/}


                <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>
                
                <button onClick={()=>{this.renderChupitosTablas("Calamar")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                <Zoom>
                <img src={calamarTabla} style={{width: '60%', maxWidth: 300}} alt="Top"/>
                <div style={{marginTop: 20}}>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 16, textAlign: 'center', marginBottom: -10, marginTop: 0}}>Desde</p>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 50, textAlign: 'center', marginBottom: -30, marginTop: 0}}>9 €</p>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 22, textAlign: 'center'}}>{this.state.languageEnglish ? '4 shots' : '4 chupitos'}</p>
                </div>
                </Zoom>
                </div>
                </button>

                {this.state.tablaCalamarState
                ?
                <div style={{width: '95%', margin: 'auto', alignItems: 'center', justifyContent: 'space-between', margin: 20, marginTop: 0}}>
                <Zoom>
                <p className='style5Font' style={{fontSize: 16, color: 'black', marginRight: 10, marginLeft: 10}}>{this.state.languageEnglish ? 'Emergency Meeting! Although these shots all look the same ': '¡Emergency Meeting! ¿Listos para el desafío? Los chupitos de esta tabla parecen todos iguales '} <span className='style5Font' style={{color: 'color', fontSize: 16, fontWeight: 'bold'}}>{this.state.languageEnglish ? '(Lollipop Liqueur + Candy + Grenadine)': '(Licor de Piruleta + Caramelo + Granadina)'}</span>{this.state.languageEnglish ? ', but they dont. Per ': ', pero no lo son. Por cada '} <span className='style5Font' style={{color: '#7a0000', fontSize: 16, fontWeight: 'bold'}}>{this.state.languageEnglish ? '3 SOLDIERS ': '3 SOLDADOS '}</span>{this.state.languageEnglish ?'there is ' : 'hay '}<span className='style5Font' style={{color: '#7a0000', fontSize: 16, fontWeight: 'bold'}}>{this.state.languageEnglish ?'1 IMPOSTOR (Absinthe)': '1 IMPOSTOR (Absenta)'}</span>{this.state.languageEnglish ?'. Toast with your friends, and find out which among you is the impostor! ': '. Brinda, apoya, bebe y descubre quién es el impostor'}</p>
                </Zoom>
                <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'space-around'}}>
                <Fade left>
                <img src={amongUs1} style={{height: 70}} alt="Top"/>
                </Fade>
                <Fade right>
                <img src={amongUs2} style={{height: 90}} alt="Top"/>
                </Fade>
                </div>
                </div>
                :
                null
                }

                


                {/*AVENGERS




                <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>





                <button onClick={()=>{this.renderChupitosTablas("Avengers")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                <Zoom>
                <img src={avengersTabla} style={{width: '60%', maxWidth: 300}} alt="Top"/>
                <div style={{marginTop: 20}}>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 50, textAlign: 'center', marginBottom: -30, marginTop: 0}}>12 €</p>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 22, textAlign: 'center'}}>{this.state.languageEnglish ? '5 shots' : '5 chupitos'}</p>
                </div>
                </Zoom>
                </div>
                </button>

                {this.state.tablaAvengersState
                ?
                <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#3d85c6', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'CAPTAIN AMERICA: ' : 'CAPITÁN AMÉRICA: '} <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Blueberry Liqueur + Grenadine + Blue Curaçao' : 'Licor de Arándano + Granadina + Curaçao Azul'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#b15e89', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'HAWKEYE: ' : 'OJO DE HALCÓN: '} <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Rum + Blackberry' : 'Ron + Mora'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#da4a4a', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>IRON MAN: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Rum + Grenadine + Bitters' : 'Ron + Granadina + Angostura'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#ecb939', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>THOR: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Honey + Bourbon' : 'Vodka + Miel + Bourbon'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#6aa84f', fontSize: 20}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>HULK: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Green Absinthe + Blueberry Liqueur' : 'Absenta Verde + Licor de Arándano'}</span></p>
                </div>
                </Bounce>
                </div>
                :
                null
                }
                */}

                {/*TOY STORY




                <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>





                <button onClick={()=>{this.renderChupitosTablas("ToyStory")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                <Zoom>
                <img src={toyStoryTabla} style={{width: '50%', maxWidth: 250, marginLeft: 10}} alt="Top"/>
                <div style={{marginTop: 20}}>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 50, textAlign: 'center', marginBottom: -30, marginTop: 0}}>12 €</p>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 22, textAlign: 'center'}}>{this.state.languageEnglish ? '5 shots' : '5 chupitos'}</p>
                </div>
                </Zoom>
                </div>
                </button>

                {this.state.tablaToyStoryState
                ?
                <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#fed10b', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>WOODY: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Passion Fruit Tequila + Chocolate + Red Absinthe' : 'Tequila de Mango + Chocolate + Absenta Roja'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#88cb6c', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>BUZZ LIGHTYEAR: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Absinthe + Rice Pudding Liqueur + Green Banana' : 'Absenta + Licor de Arroz con Leche + Plátano Verde'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#ce73a7', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'LOTSO: ' : 'LOTSO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Strawberry Tequila + Strawberry Syrup' : 'Tequila de Fresa + Sirope de Fresa'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#6f3088', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>ZURG: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Black Absinthe + Passion Fruit + Grenadine + Violet' : 'Absenta Negra + Mango + Granadina + Violeta'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#2b9c21', fontSize: 20}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'MARTIAN: ' : 'MARCIANO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Kiwi + Apple Liqueur + Blue Curaçao' : 'Kiwi + Licor de Manzana + Curaçao Azul'}</span></p>
                </div>
                </Bounce>
                </div>
                :
                null
                }

                */}
                
                


                {/*HORA DE AVENTURAS




                <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>





                <button onClick={()=>{this.renderChupitosTablas("Aventuras")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                <Zoom>
                <img src={aventurasTabla} style={{width: '60%', maxWidth: 300}} alt="Top"/>
                <div style={{marginTop: 20}}>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 50, textAlign: 'center', marginBottom: -30, marginTop: 0}}>12 €</p>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 22, textAlign: 'center'}}>{this.state.languageEnglish ? '5 shots' : '5 chupitos'}</p>
                </div>
                </Zoom>
                </div>
                </button>

                {this.state.tablaAventurasState
                ?
                <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#3d85c6', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1  }}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>FINN: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Kiwi Liqueur + Rice Pudding Liqueur + Blue Curaçao' : 'Licor de Kiwi + Licor de Arroz con Leche + Curaçao Azul'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#fecf25', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>JAKE: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Banana Liqueur + Hazelnut Liqueur + Caramel Vodka' : 'Licor de Plátano + Licor de Avellana + Vodka de Caramelo'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#d685d6', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1  }}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'PRINCESS BUBBLEGUM: ' : 'PRINCESA CHICLE: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Strawberry Tequila + Blackberry Liqueur + Vodka + Sugar' : 'Tequila de Fresa + Licor de Mora + Vodka + Azúcar'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#fe3434', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>MARCELINE: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Red Absinthe + Red Martini + Bitters' : 'Absenta Roja + Martini Rojo + Angostura'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#0148cb', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'ICE KING: ' : 'REY HIELO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Peach Liqueur + Triple Sec + Blue Curaçao + Rice Pudding' : 'Licor de Melocotón + Triple Seco + Curaçao Azul + Arroz con Leche'}</span></p>
                </div>
                </Bounce>
                </div>
                :
                null
                }
                */}

                 {/*NAVIDAD


                 <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>
                
                <button onClick={()=>{this.renderChupitosTablas("Navidad")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                <Zoom>
                <img src={navidadTabla} style={{width: '60%', maxWidth: 300}} alt="Top"/>
                <div style={{marginTop: 20}}>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 50, textAlign: 'center', marginBottom: -30, marginTop: 0}}>10 €</p>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 22, textAlign: 'center'}}>{this.state.languageEnglish ? '6 shots' : '6 chupitos'}</p>
                </div>
                </Zoom>
                </div>
                </button>

                {this.state.tablaNavidadState
                ?
                <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                <Bounce left>
                <div style={{}}>
                <p className='style5Font' style={{color: '#bd8a14', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'ROSCONCITO: ' : 'ROSCONCITO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Mandarine Liqueur + Triple Sec + Orange Blossom Water + Sugar + Whipped Cream' : 'Licor de Mandarina + Triple Seco + Agua de Azar + Azúcar + Nata'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div style={{}}>
                <p className='style5Font' style={{color: '#294e08', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'AFTER EIGHT: ' : 'AFTER EIGHT: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka +Chocolate Syrup + Peppermint' : 'Vodka + Sirope de Chocolate + Peppermint'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div style={{}}>
                <p className='style5Font' style={{color: '#d3bb5a', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'CHUPOLVORON: ' : 'CHUPOLVORON: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Orujo Cream + Almond Liqueur + Sugar' : 'Crema de Orujo + Licor de Almendra + Azúcar Glas'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div style={{}}>
                <p className='style5Font' style={{color: '#cd7e42', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'PONCHITO DE HUEVO: ' : 'PONCHITO DE HUEVO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vanilla Syrup + Cinamon Liqueur + Egg Liqueur' : 'Sirope de Vainilla + Licor de Canela+ Licor ponche de huevo'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div style={{}}>
                <p className='style5Font' style={{color: '#dcbf2e', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'CHUPITURRÓN: ' : 'CHUPITURRÓN: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Ron + Almond Liqueur + Honey' : 'Ron + Licor de Almendras + Miel'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div style={{}}>
                <p className='style5Font' style={{color: '#9e502e', fontSize: 20 }}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'FERRERO: ' : 'FERRERO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Chocolate Syrup + Hazelnut Syrup + Hazelnut' : 'Vodka + Sirope de Chocolate + Licor de Avellana + Avellanas'}</span></p>
                </div>
                </Bounce>
                </div>
                :
                null
                }
                */}




                {/*POCIONES*/}



                <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>



                <button onClick={()=>{this.renderChupitosTablas("Pociones")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                <Zoom>
                <img src={pocionesTabla} style={{width: '60%', maxWidth: 300}} alt="Top"/>
                <div style={{marginTop: 20}}>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 50, textAlign: 'center', marginBottom: -30, marginTop: 0}}>15 €</p>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 22, textAlign: 'center'}}>{this.state.languageEnglish ? '6 shots' : '6 chupitos'}</p>
                </div>
                </Zoom>
                </div>
                </button>

                {this.state.tablaPocionesState
                ?
                <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#efc852', fontSize: 20}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>FELIX FELICIS: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Punche + Lime' : 'Ponche + Lima'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#668b32', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'POLYJUICE POTION: ' : 'POCIÓN MULTIJUGOS: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Black Vodka + Melon Liqueur + Baileys' : 'Vodka Negro + Licor de Melón + Baileys'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#87d4bf', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>VERITASERUM: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'White Rum + Coconut Liqueur' : 'Ron Blanco + Licor de Coco'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#ec970e', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'MANDRAKE JUICE: ' : 'ZUMO DE MANDRÁGORA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Gin + Passion Fruit' : 'Ginebra + Maracuyá'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#e70d85', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'LOVE POTION: ' : 'FILTRO DE AMOR: '} <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Red Absinthe + Sangria Concentrate' : 'Absenta Roja + Concentrado de Sangría'}</span></p>
                </div>
                </Bounce>

                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#7f4f96', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'SKELE-GRO: ' : 'CRECEHUESOS: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Black Absinthe + Rice Pudding Liqueur' : 'Absenta Negra + Licor de Arroz con Leche'}</span></p>
                </div>
                </Bounce>
                </div>
                :
                null
                }




                {/*INSIDE OUT*/}



                <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>



                <button onClick={()=>{this.renderChupitosTablas("Inside Out")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                <Zoom>
                <img src={insideOutTabla3} style={{width: '60%', maxWidth: 300}} alt="Top"/>
                <div style={{marginTop: 20}}>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 50, textAlign: 'center', marginBottom: -30, marginTop: 0}}>15 €</p>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 22, textAlign: 'center'}}>{this.state.languageEnglish ? '6 shots' : '6 chupitos'}</p>
                </div>
                </Zoom>
                </div>
                </button>

                {this.state.tablaInsideOut
                ?
                <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#fcd731', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1  }}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'JOY: ' : 'ALEGRÍA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Limoncello Cream + Cotton Candy Liqueur + Peta-Zetas' : 'Crema de Limoncello + Licor de Nube + Peta-Zetas'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#318cfc', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1  }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'SADNESS: ' : 'TRISTEZA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Cotton Candy Liqueur + Blue Absinthe' : 'Licor de Nube + Absenta Azul'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#c903c9', fontSize: 20  }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'FEAR: ' : 'MIEDO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Violet + Cold Vodka + Lollipop Liqueur + Grenadine' : 'Violeta + Vodka Frío + Licor de Piruleta + Granadina'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#00c750', fontSize: 20}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'DISGUST: ' : 'ASCO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Kiwi + Limoncello + Blue Absinthe + Bitters' : 'Kiwi + Limoncello + Absenta Azul + Angostura'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#b30000', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={fuego} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'ANGER: ' : 'IRA: '} <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Grenadine + Coconut Liqueur + Red Absinthe + Fire' : 'Granadina + Licor de Coco + Absenta Roja + Fuego'}</span></p>
                </div>
                </Bounce>

                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#fa9600', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'ANXIETY: ' : 'ANSIEDAD: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Thunderbitch + Mango and Passion Fruit Liqueur + Pepper' : 'Thunderbitch + Licor de Mango y Maracuyá + Pimienta'}</span></p>
                </div>
                </Bounce>
                </div>
                :
                null
                }


                {/*POWER RANGERS*/}



                <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>



                <button onClick={()=>{this.renderChupitosTablas("Rangers")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                <Zoom>
                <img src={powerRangersTabla} style={{width: '60%', maxWidth: 300}} alt="Top"/>
                <div style={{marginTop: 20}}>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 50, textAlign: 'center', marginBottom: -30, marginTop: 0}}>15 €</p>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 22, textAlign: 'center'}}>{this.state.languageEnglish ? '6 shots' : '6 chupitos'}</p>
                </div>
                </Zoom>
                </div>
                </button>

                {this.state.tablaRangersState
                ?
                <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#e40101', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'RED: ' : 'ROJO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Watermelon Liqueur' : 'Licor de Sandía'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#0154e4', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'BLUE: ' : 'AZUL: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Blue Curaçao' : 'Curaçao Azul'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#ff9fe3', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'PINK: ' : 'ROSA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Strawberry Tquila' : 'Tequila de Fresa'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#f4d701', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'YELLOW: ' : 'AMARILLO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Banana Liqueur' : 'Licor de Plátano'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#09001e', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'BLACK: ' : 'NEGRO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Black Vodka' : 'Vodka Negro'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#01b23c', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'GREEN: ' : 'VERDE: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Kiwi Liqueur' : 'Licor de Kiwi'}</span></p>
                </div>
                </Bounce>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10}}>
                    <Zoom>
                    <img src={mezclaPowerRangers} style={{height: 60}} alt="Top"/>
                    <p className='style5Font' style={{fontSize: 16, color: 'black', marginLeft: 10}}>{this.state.languageEnglish ? 'All of the shots can be mixed with the alcohol of your choice ' : 'Si quieres podemos mezclar todos los chupitos con el alcohol que elijas '}<span className='style5Font' style={{color: 'black', fontSize: 16, fontWeight: 'bold'}}>{this.state.languageEnglish ? '¡FOR FREE!' : '¡GRATIS!'}</span> {this.state.languageEnglish ? 'between: ' : 'entre: '}<span className='style5Font' style={{color: 'black', fontSize: 16, fontWeight: 'bold'}}>{this.state.languageEnglish ? 'Tequila, Rum, Vodka, Gin or Whiskey' : 'Tequila, Ron, Vodka, Ginebra o Whiskey'}</span></p>
                    
                    </Zoom>
                </div>
                </div>
                :
                null
                }


                {/*ROCKY HORROR



                <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>



                <button onClick={()=>{this.renderChupitosTablas("Rocky")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                <Zoom>
                <img src={rockyHorrorTabla} style={{width: '60%', maxWidth: 300}} alt="Top"/>
                <div style={{marginTop: 20}}>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 50, textAlign: 'center', marginBottom: -30, marginTop: 0}}>15 €</p>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 22, textAlign: 'center'}}>{this.state.languageEnglish ? '6 shots' : '6 chupitos'}</p>
                </div>
                </Zoom>
                </div>
                </button>

                {this.state.tablaRockyState
                ?
                <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>

                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10}}>
                    <Bounce right>
                    <p className='style5Font' style={{fontSize: 16, color: 'black', textAlign: 'center'}}>{this.state.languageEnglish ? 'Without a doubt, this is our most tropical shot combo. Each shot has a base of ' : 'Sin duda nuestra tabla más tropical. Cada chupito lleva una base de '}<span className='style5Font' style={{color: 'black', fontSize: 16, fontWeight: 'bold'}}>{this.state.languageEnglish ? 'WHITE RUM' : 'RON BLANCO'}</span> {this.state.languageEnglish ? ' and ' : ' y '}<span className='style5Font' style={{color: 'black', fontSize: 16, fontWeight: 'bold'}}>SPRITE</span> {this.state.languageEnglish ? 'combined with a different flavor: ' : 'combinada con un sabor diferente: '}<span className='style5Font' style={{color: '#9c25fe', fontSize: 16, fontWeight: 'bold'}}>{this.state.languageEnglish ? 'COCONUT' : 'COCO'}</span>, <span className='style5Font' style={{color: '#e4c201', fontSize: 16, fontWeight: 'bold'}}>{this.state.languageEnglish ? 'PINEAPPLE' : 'PIÑA'}</span>, <span className='style5Font' style={{color: '#4525fe', fontSize: 16, fontWeight: 'bold'}}>{this.state.languageEnglish ? 'BLUE CURAÇAO' : 'CURAÇAO AZUL'}</span>, <span className='style5Font' style={{color: '#e47701', fontSize: 16, fontWeight: 'bold'}}>{this.state.languageEnglish ? 'PASSION FRUIT' : 'MARACUYÁ'}</span>, <span className='style5Font' style={{color: '#68b201', fontSize: 16, fontWeight: 'bold'}}>MANGO</span>{this.state.languageEnglish ? ' AND ' : ' Y '}<span className='style5Font' style={{color: '#ef0101', fontSize: 16, fontWeight: 'bold'}}>{this.state.languageEnglish ? 'STRAWBERRY' : 'FRESA'}</span></p>
                    
                    </Bounce>
                </div>

                </div>
                :
                null
                }
                */}


                {/*DISNEY*/}



                <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>



                <button onClick={()=>{this.renderChupitosTablas("Disney")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                <Zoom>
                <img src={disneyTabla} style={{width: '60%', maxWidth: 300}} alt="Top"/>
                <div style={{marginTop: 20}}>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 50, textAlign: 'center', marginBottom: -30, marginTop: 0}}>18 €</p>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 22, textAlign: 'center'}}>{this.state.languageEnglish ? '7 shots' : '7 chupitos'}</p>
                </div>
                </Zoom>
                </div>
                </button>

                {this.state.tablaDisneyState
                ?
                <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#ef0101', fontSize: 20}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'EVIL STEPMOTHER: ' : 'MADRASTRA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Black Vodka + Lollipop Liqueur + Apple Liqueur' : 'Vodka Negro + Licor de Piruleta + Licor de Manzana'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#b2a4a4', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'CRUELLA: ' : 'CRUELLA DE VIL: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Chocolate Syrup + Coconut Liqueur + Rice Pudding Liqueur + Grenadine' : 'Sirope de Chocolate + Licor de Coco + Licor de Arroz con Leche + Granadina'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#f6c823', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'HOOK: ' : 'GARFIO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Honey Rum + Banana Liqueur' : 'Ron Miel + Licor de Plátano'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#bc0187', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>ÚRSULA: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Violet Syrup + Rice Pudding Liqueur + Black Absinthe' : 'Sirope de Violeta + Licor de Arroz con leche + Absenta Negra'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#39951d', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'MALEFICENT: ' : 'MALÉFICA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Kiwi + Violet Syrup + Black Absinthe' : 'Kiwi + Sirope de Violeta + Absenta Negra'}</span></p>
                </div>
                </Bounce>

                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#ff6161', fontSize: 20}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>JAFAR: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Falernum + Grenadine + Limoncello + Black Absinthe' : 'Falernum + Granadina + Limoncello + Absenta Negra'}</span></p>
                </div>
                </Bounce>

                <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#6181ff', fontSize: 20}}><span><img src={fuego} style={{height: 25, marginRight: 2, marginBottom: -2}} alt="Top"/></span>HADES: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Blue Vodka + Blue Absinthe + Fire' : 'Vodka Azul + Absenta Azul + Fuego'}</span></p>
                </div>
                </Bounce>
                </div>
                :
                null
                }


                {/*ROCK STAR*/}



                <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>



                <button onClick={()=>{this.renderChupitosTablas("RockStar")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                <Zoom>
                <img src={rockStarTabla} style={{width: '60%', maxWidth: 300}} alt="Top"/>
                <div style={{marginTop: 20}}>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 50, textAlign: 'center', marginBottom: -30, marginTop: 0}}>21 €</p>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 22, textAlign: 'center'}}>{this.state.languageEnglish ? '8 shots' : '8 chupitos'}</p>
                </div>
                </Zoom>
                </div>
                </button>

                {this.state.tablaRockStarState
                ?
                <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#fec34d', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>BOM-BON JOVI: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Coffee Liqueur + Condensed Milk' : 'Licor de Café + Leche Condensada'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#fe4d4d', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>MICK JÄGGERMEISTER: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Jägermeister + Lollipop Liqueur + Grenadine' : 'Jägermeister + Licor de Piruleta + Granadina'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#a9561e', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>DAVID BROWNIE: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Chocolate Tequila + Brandy + Baileys' : 'Tequila de Chocolate + Brandy + Baileys'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#e9d820', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>FREDDO MERCURY: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Banana Liqueur + Grenadine' : 'Vodka + Licor de Plátano + Granadina'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#b413c3', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>CHUCK BERRYS: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Strawberry Liqueur + Blueberry Liqueur' : 'Vodka + Licor de Fresa + Licor de Arándanos'}</span></p>
                </div>
                </Bounce>

                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#eea94f', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>KURT COCOBAIN: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Bourbon + Coconut Liqueur' : 'Bourbon + Licor de Coco'}</span></p>
                </div>
                </Bounce>

                <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#dce01a', fontSize: 20}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>JOHN LEMMON: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Whiskey + Limoncello + Bitters' : 'Whiskey + Limoncello + Angostura'}</span></p>
                </div>
                </Bounce>

                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#ed7a45', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>JANÍS JOPLIN: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Mandarin Liqueur + Blueberry Liqueur + Green Absinthe' : 'Licor de Mandarina + Licor de Arándano + Absenta Verde'}</span></p>
                </div>
                </Bounce>
                </div>
                :
                null
                }

                {/*JUEGO DE TRONOS*/}



                <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>



                <button onClick={()=>{this.renderChupitosTablas("Tronos")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                <Zoom>
                <img src={tronosTabla} style={{width: '60%', maxWidth: 300}} alt="Top"/>
                <div style={{marginTop: 20}}>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 50, textAlign: 'center', marginBottom: -30, marginTop: 0}}>24 €</p>
                <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 22, textAlign: 'center'}}>{this.state.languageEnglish ? '9 shots' : '9 chupitos'}</p>
                </div>
                </Zoom>
                </div>
                </button>

                {this.state.tablaTronosState
                ?
                <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#1a6ce0', fontSize: 20}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>TULLY: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Blue Curaçao + Grenadine' : 'Vodka + Curaçao Azul + Granadina'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#16c044', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>TYRELL: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Tequila + Kiwi' : 'Tequila + Kiwi'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#ad81ca', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>STARK: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Coconut Liqueur' : 'Vodka + Licor de Coco'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#b57026', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>GREYJOY: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Bourbon + Coffee Liqueur' : 'Bourbon + Licor de Café'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#1faae5', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>ARRYN: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Gin + Blue Tropic' : 'Ginebra + Blue Tropic'}</span></p>
                </div>
                </Bounce>

                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#e83b3b', fontSize: 20}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>LANNISTER: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Whiskey + Red Vermouth + Bitters' : 'Whiskey + Vermú Rojo + Angostura'}</span></p>
                </div>
                </Bounce>

                <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#c75c5c', fontSize: 20}}><span><img src={picante} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>MARTELL: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Tequila + Grenadine + Tabasco' : 'Tequila + Granadina + Tabasco'}</span></p>
                </div>
                </Bounce>

                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#e6cc0a', fontSize: 20}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>BARATHEON: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Banana Liqueur + Black Absinthe' : 'Licor de Plátano + Absenta Negra'}</span></p>
                </div>
                </Bounce>

                <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#e41b1b', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuego} style={{height: 25, marginRight: 2, marginBottom: -2, opacity: this.state.venganFilter ? 0.15 : 1}} alt="Top"/></span>TARGARYEN: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Black Absinthe + Watermelon Liqueur + Dragon Fire' : 'Absenta Negra + Licor de Sandía + Fuego de Dragón'}</span></p>
                </div>
                </Bounce>
                </div>
                :
                null
                }
                </div>
                
        )
    }

    renderChupitos(){
        return(
            <div id="chupitos" style={{display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center'}}>
            <div style={{width: '90%', height: 2, backgroundColor: '#CF1009'}}></div>
            <Fade bottom>
            <p className='style10Font' style={{fontSize: 40, color: '#b00d07', textAlign: 'center', marginBottom: 30}}>{this.state.languageEnglish ? 'Shots 3€' : 'Chupitos 3€'}</p>
            </Fade>

            <Fade bottom>
            <div style={{display: 'flex', flexDirection: 'column', width: '90%', alignItems: 'center', justifyContent: 'center'}}>
            <img src={chupitosComplemento} style={{width: '30%', maxWidth: 100}} alt="Top"/>
            {/*
            <div style={{display: 'flex', width: '100%', alignItems: 'flex-end', justifyContent: 'center'}}>
            <img src={chupitosComplemento} style={{width: '35%', maxWidth: 150}} alt="Top"/>
            <img src={chupitosComplemento2} style={{width: '30%', maxWidth: 120}} alt="Top"/>
            </div>
            */}
            <p className='style9Font' style={{fontSize: 22, fontWeight: 'bold', color: 'black', textAlign: 'center', marginTop: 10}}>{this.state.languageEnglish ? 'You can customize any shot on the menu by adding:' : 'Si quereis, podeis personalizar los chupitos de la carta añadiendoles:'}</p>
            </div>
            <div style={{width: '90%'}}>
            <p className='style9Font' style={{fontSize: 16, fontWeight: 'bold', color: 'black', marginTop: 0}}>{this.state.languageEnglish ? '· Pop Rocks, Chupa Chups or Tabasco: ' : '· Peta-Zetas, Chupa Chups o Tabasco: '}<span style={{fontSize: 18, fontWeight: 'bold'}}>+0,5€ </span></p>
            <p className='style9Font' style={{fontSize: 16, fontWeight: 'bold', color: 'black', marginTop: 0}}>{this.state.languageEnglish ? '· Single shots: ' : '· Chupitos de un solo licor: '}<span style={{fontSize: 18, fontWeight: 'bold'}}>3€ </span></p>
            <p className='style9Font' style={{fontSize: 16, fontWeight: 'bold', color: 'black', marginTop: 0}}>{this.state.languageEnglish ? '· Premium shots*: ' : '· Chupitos premium*'}<span style={{fontSize: 18, fontWeight: 'bold'}}>4€ </span></p>
            <p className='style9Font' style={{fontSize: 14, color: 'black', marginTop: 10}}>{this.state.languageEnglish ? '*Jack Daniels, Hendricks, Havana Club 7 years, Bombay Sapphire, Bulldog, Mezcal, José Cuervo or Absinthe' : '*Jack Daniels, Hendricks, Havana Club 7 años, Bombay Sapphire, Bulldog, Mezcal, José Cuervo o Absenta'}</p>
            </div>
            </Fade>


            {/*Suaves*/}

            <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15, marginTop: 20, marginBottom: 10}}></div>

            <button onClick={()=>{this.renderChupitosIndividuales("Suaves")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                <Zoom>
                <img src={chupitosSuaves} style={{width: '50%', maxWidth: 250}} alt="Top"/>
                <img src={suaves} style={{width: '12%', maxWidth: 120, marginTop: 10, marginRight: 3}} alt="Top"/>
                </Zoom>
                </div>
                </button>

                {this.state.chupitosSuavesState
                ?
                <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                <Bounce left>
                <div style={{}}>
                    <p className='style5Font' style={{color: '#199603', fontSize: 20 }}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'TOY STORY MARTIAN: ' : 'MARCIANO TOY STORY: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Kiwi + Apple Liqueur + Blue Curaçao' : 'Kiwi + Licor de Manzana + Curaçao Azul'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#50749f', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>R2D2: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Rice Pudding Liqueur' : 'Licor de Arroz con Leche + Curaçao Azul'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#e18c05', fontSize: 20 }}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>PORTAL: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Blue Curaçao + Passion Fruit' : 'Maracuyá + Curaçao Azul'}</span></p>
                </div>
                </Bounce>
                {/*
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#1468c8', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'CAPTAIN AMERICA: ' : 'CAPITÁN AMÉRICA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Blueberry Liqueur + Grenadine + Blue Curaçao' : 'Licor de Arándano + Granadina + Curaçao Azul'}</span></p>
                </div>
                </Bounce>
                */}
                {/*
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#be4690', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1  }}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'PRINCESS BUBBLEGUM: ' : 'PRINCESA CHICLE: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Strawberry Tequila + Blackberry Liqueur + Vodka + Sugar' : 'Tequila de Fresa + Licor de Mora + Vodka + Azúcar'}</span></p>
                </div>
                </Bounce>
                */}
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#a25c39', fontSize: 20}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'CHIP & DALE: ' : 'CHIP Y CHOP: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Hazelnut Liqueur + Almond Liqueur' : 'Licor de Avellanas + Licor de Almendras'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#42a239', fontSize: 20 }}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'SLIMER: ' : 'MOQUETE: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Coconut Liqueur + Kiwi Liqueur + Kiwi Syrup' : 'Licor de Coco + Licor de Kiwi + Sirope de Kiwi'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#d91717', fontSize: 20}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'SPIDERMAN: ' : 'SPIDERMAN: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Blue Vodka + Grenadine' : 'Vodka Azul + Granadina'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#de8b17', fontSize: 20}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'FELIX FELICIS: ' : 'FELIX FELICIS: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Ponche + Lime' : 'Ponche + Lima'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#9d5b10', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'BOM-BON JOVI: ' : 'BOM-BON JOVI: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Coffee Liqueur + Condensed Milk' : 'Licor de Café + Leche Condensada'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#3042a6', fontSize: 20 }}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'RAVENCLAW: ' : 'RAVENCLAW: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Blue Curaçao + Black Vodka' : 'Curaçao Azul + Vodka Negro'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#ceae2c', fontSize: 20}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'HUFFLEPUFF: ' : 'HUFFLEPUFF: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Banana Liqueur + Black Vodka' : 'Licor de Plátano + Vodka Negro'}</span></p>
                </div>
                </Bounce>
                
                {/*
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#0488b4', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'FINN: ' : 'FINN: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Kiwi Liqueur + Rice Pudding Liqueur + Blue Curaçao' : 'Licor de Kiwi + Licor de Arroz con Leche + Curaçao Azul'}</span></p>
                </div>
                </Bounce>
                */}
                <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#78675e', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'CRUELLA: ' : 'CRUELLA DE VIL: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Chocolate Syrup + Coconut Liqueur + Rice Pudding Liqueur + Grenadine' : 'Sirope de Chocolate + Licor de Coco + Licor de Arroz con Leche + Granadina'}</span></p>
                </div>
                </Bounce>

                <Bounce right>
                <div>
                    <p className='style5Font' style={{color: '#975620', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'ET: ' : 'ET: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Rice Pudding Liqueur + Chocolate Tequila + Cinnamon' : 'Licor de Arroz con Leche + Tequila de Chocolate + Canela'}</span></p>
                </div>
                </Bounce>
                {/*
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#238811', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'THE CHILD: ' : 'BABY YODA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Pistachio Cream Liqueur + Chocolate Tequila + Rice Pudding Liqueur' : 'Licor de Crema de Pistacho + Tequila de Chocolate + Licor de Arroz con Leche'}</span></p>
                </div>
                </Bounce>
                */}
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#917646', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={picante} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'TROLL SNOT: ' : 'MOCO DE TROLL: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Honey Rum + Ginger Syrup + Honey + Wand' : 'Ron Miel + Sirope de Jengibre + Miel + Varita'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#ce2c2c', fontSize: 20}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'GRYFFINDOR: ' : 'GRYFFINDOR: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Licor 43 + Grenadine + Vodka' : 'Licor 43 + Granadina + Vodka'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#1a6ce0', fontSize: 20 }}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'TULLY: ' : 'TULLY: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Blue Curaçao + Grenadine' : 'Vodka + Curaçao Azul + Granadina'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                    <p className='style5Font' style={{color: '#fcd731', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1  }}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'JOY: ' : 'ALEGRÍA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Limoncello Cream + Cotton Candy Liqueur + Peta-Zetas' : 'Crema de Limoncello + Licor de Nube + Peta-Zetas'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#ef0101', fontSize: 20}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'THE STEPMOTHER: ' : 'MADRASTRA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Black Vodka + Lollipop Liqueur + Apple Liqueur' : 'Vodka Negro + Licor de Piruleta + Licor de Manzana'}</span></p>
                </div>
                </Bounce>
                <Bounce right>
                <div>
                    <p className='style5Font' style={{color: '#ecb939', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'BLOWJOB: ' : 'BLOWJOB: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Coffee Liqueur + Banana Liqueur + Baileys + Whipped Cream' : 'Licor de Café + Licor de Plátano + Baileys + Nata'}</span></p>
                </div>
                </Bounce>
                <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#668b32', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'POLYJUICE POTION: ' : 'POCIÓN MULTIJUGOS: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Black Vodka + Melon Liqueur + Baileys' : 'Vodka Negro + Licor de Melón + Baileys'}</span></p>
                </div>
                </Bounce>
                </div>
                :
                null
                }

            {/*Fuertes*/}

            <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15, marginTop: 20, marginBottom: 10}}></div>

            <button onClick={()=>{this.renderChupitosIndividuales("Fuertes")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
            <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
            <Zoom>
            <img src={chupitosFuertes} style={{width: '50%', maxWidth: 250}} alt="Top"/>
            <img src={fuertes} style={{width: '12%', maxWidth: 120, marginRight: 2}} alt="Top"/>
            </Zoom>
            </div>
            </button>

            {this.state.chupitosFuertesState
            ?
            <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#e4bc4e', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'C3PO: ' : 'C3PO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Gin + Lime + Bitters' : 'Ginebra + Lima + Angostura'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#ec970e', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'MANDRAKE JUICE: ' : 'ZUMO DE MANDRÁGORA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Gin + Passion Fruit' : 'Ginebra + Maracuyá'}</span></p>
            </div>
            </Bounce>
            {/*
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#b15e89', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'HAWKEYE: ' : 'OJO DE HALCÓN: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Rum + Blackberry' : 'Ron + Mora'}</span></p>
            </div>
            </Bounce>
            */}

            <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#c903c9', fontSize: 20  }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'FEAR: ' : 'MIEDO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Violet + Cold Vodka + Lollipop Liqueur + Grenadine' : 'Violeta + Vodka Frío + Licor de Piruleta + Granadina'}</span></p>
                </div>
            </Bounce>
            
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#16c044', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'TYRELL: ' : 'TYRELL: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Tequila + Kiwi' : 'Tequila + Kiwi'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#c75c5c', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'MARTELL: ' : 'MARTELL: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Tequila + Grenadine + Tabasco' : 'Tequila + Granadina + Tabasco'}</span></p>
            </div>
            </Bounce>
            {/*
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#da4a4a', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'IRON MAN: ' : 'IRON MAN: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Rum + Grenadine + Bitters' : 'Ron + Granadina + Angostura'}</span></p>
            </div>
            </Bounce>
            */}

            <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#fa9600', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'ANXIETY: ' : 'ANSIEDAD: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Thunderbitch + Mango and Passion Fruit Liqueur + Pepper' : 'Thunderbitch + Licor de Mango y Maracuyá + Pimienta'}</span></p>
                </div>
            </Bounce>
            
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#1faae5', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'ARRYN: ' : 'ARRYN: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Gin + Blue Tropic' : 'Ginebra + Blue Tropic'}</span></p>
            </div>
            </Bounce>
            {/*
            <Bounce right>
            <div>
                <p className='style5Font' style={{color: '#ce73a7', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'LOTSO: ' : 'LOTSO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Strawberry Tequila + Strawberry Syrup' : 'Tequila de Fresa + Sirope de Fresa'}</span></p>
            </div>
            </Bounce>
            */}
            <Bounce left>
            <div>
            <p className='style5Font' style={{color: '#3620d9', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'TARDIS: ' : 'TARDIS: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Blue Curaçao + 43 Liqueur + White Rum' : 'Licor de Curaçao Azul + Licor 43 + Ron Blanco'}</span></p>
            </div>
            </Bounce>
            {/*
            <Bounce right>
            <div style={{}}>
                <p className='style5Font' style={{color: '#fecf25', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'JAKE: ' : 'JAKE: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Banana Liqueur + Hazelnut Liqueur + Caramel Vodka' : 'Licor de Plátano + Licor de Avellana + Vodka de Caramelo'}</span></p>
            </div>
            </Bounce>
            */}

            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#a9561e', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'BLACK PANTHER: ' : 'BLACK PANTHER: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Coffee Liqueur + Chocolate Tequila + Cherry + Jägermeister' : 'Licor de Café + Tequila de Chocolate + Cereza + Jägermeister'}</span></p>
            </div>
            </Bounce>

            {/*
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#0148cb', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'ICE KING: ' : 'REY HIELO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Peach Liqueur + Triple Sec + Blue Curaçao + Rice Pudding' : 'Licor de Melocotón + Triple Seco + Curaçao Azul + Arroz con Leche'}</span></p>
            </div>
            </Bounce>
            */}
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#7a158e', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'FLAMING MOE´S: ' : 'FLAMEADO DE MOE: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Brandy + Pacharán + Blackberry + Peppermint' : 'Brandy + Pacharán + Mora + Peppermint'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#e9d820', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'FREDDO MERCURY: ' : 'FREDDO MERCURY: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Banana Liqueur + Grenadine' : 'Vodka + Licor de Plátano + Granadina'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#a9561e', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'DAVID BROWNIE: ' : 'DAVID BROWNIE: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Chocolate Tequila + Brandy + Baileys' : 'Tequila de Chocolate + Brandy + Baileys'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#bf891d', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'BUTTERBEER: ' : 'CERVEZA DE MANTEQUILLA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Custard Liqueur + Licor 43 + Caramel Vodka + Whipped Cream' : 'Licor de Natillas + Licor 43 + Vodka de Caramelo + Nata'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#b413c3', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'CHUCK BERRYS: ' : 'CHUCK BERRYS: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Strawberry Liqueur + Blueberry Liqueur' : 'Vodka + Licor de Fresa + Licor de Arándanos'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#ad81ca', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'STARK: ' : 'STARK: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Coconut Liqueur' : 'Vodka + Licor de Coco'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#eea94f', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'KURT COCOBAIN: ' : 'KURT COCOBAIN: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Bourbon + Coconut Liqueur' : 'Bourbon + Licor de Coco'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#b11b1b', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'NEVERLAND: ' : 'NEVERLAND: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Licor 43 + Strawberry Liqueur + Coconut Liqueur' : 'Licor 43 + Licor de Fresa + Licor de Coco'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#87d4bf', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'VERITASERUM: ' : 'VERITASERUM: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'White Rum + Coconut Liqueur' : 'Ron Blanco + Licor de Coco'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#f6c823', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'HOOK: ' : 'GARFIO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Honey Rum + Banana Liqueur' : 'Ron Miel + Licor de Plátano'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#d19e1f', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'ONE RING: ' : 'ANILLO ÚNICO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Licor 43 + Banana Liqueur' : 'Licor 43 + Licor de Plátano'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#398e15', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'MAD HATTER: ' : 'SOMBRERERO LOCO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Ginger + Limoncello' : 'Jengibre + Limoncello'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#b8906f', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'STORM: ' : 'TORMENTA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Thunderbitch + Rice Pudding Liqueur' : 'Thunderbitch + Licor de Arroz con Leche'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div style={{}}>
                <p className='style5Font' style={{color: '#fe4d4d', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'MICK JÄGGERMEISTER: ' : 'MICK JÄGGERMEISTER: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Jägermeister + Lollipop Liqueur' : 'Jägermeister + Licor de Piruleta'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div>
            <p className='style5Font' style={{color: '#3679a6', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'FROZEN: ' : 'FROZEN: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Strawberry Gin + Blue Vodka' : 'Ginebra de Fresa + Vodka Azul'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div style={{}}>
                <p className='style5Font' style={{color: '#b57026', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'GREYJOY: ' : 'GREYJOY: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Bourbon + Coffee Liqueur' : 'Bourbon + Licor de Café'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#bca920', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'JOHN LEMMON: ' : 'JOHN LEMMON: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Whiskey + Limoncello + Bitters' : 'Whiskey + Limoncello + Angostura'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#e83b3b', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'LANNISTER: ' : 'LANNISTER: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Whiskey + Red Vermouth + Bitters' : 'Whiskey + Vermú Rojo + Angostura'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#c9a11d', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'WOLVERINE: ' : 'LOBEZNO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Whisky + Honey Rum' : 'Whisky + Ron Miel'}</span></p>
            </div>
            </Bounce>
            {/*
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#ecb939', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'THOR: ' : 'THOR: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Honey + Bourbon' : 'Vodka + Miel + Bourbon'}</span></p>
            </div>
            </Bounce>
            */}
            </div>
            :
            null
            }

            {/*Flipas*/}

            <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15, marginTop: 20, marginBottom: 10}}></div>

            <button onClick={()=>{this.renderChupitosIndividuales("Flipas")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
            <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
            <Zoom>
            <img src={chupitosFlipas} style={{width: '45%', maxWidth: 250}} alt="Top"/>
            <img src={flipas} style={{width: '12%', maxWidth: 120, marginRight: 4}} alt="Top"/>
            </Zoom>
            </div>
            </button>

            {this.state.chupitosFlipasState
            ?
            <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#39951d', fontSize: 20 }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'MALEFICENT: ' : 'MALÉFICA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Kiwi + Violet Syrup + Black Absinthe' : 'Kiwi + Sirope de Violeta + Absenta Negra'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#1c6e28', fontSize: 20}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>SLYTHERIN: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Kiwi + Black Absinthe' : 'Kiwi + Absenta Negra'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div>
                <p className='style5Font' style={{color: '#305269', fontSize: 20 }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'BATMAN: ' : 'BATMAN: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Blue Absinthe + Blackberry Liqueur' : 'Absenta Azul + Licor de Mora'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#e70d85', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'LOVE POTION: ' : 'FILTRO DE AMOR: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Red Absinthe + Sangria Concentrate' : 'Absenta Roja + Concentrado de Sangría'}</span></p>
            </div>
            </Bounce>
            {/*
            <Bounce left>
            <div>
            <p className='style5Font' style={{color: '#6f3088', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>ZURG: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Black Absinthe + Passion Fruit + Grenadine + Violet' : 'Absenta Negra + Mango + Granadina + Violeta'}</span></p>
            </div>
            </Bounce>
            */}
            <Bounce left>
            <div>
                <p className='style5Font' style={{color: '#0183da', fontSize: 20 }}><span><img src={fuego} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'GOBLET OF FIRE: ' : 'CÁLIZ DE FUEGO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Blue Curaçao + Blue Absinthe + Cinnamon + Fire' : 'Curaçao Azul + Absenta Azul + Canela + Fuego'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#bc0187', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'URSULA: ' : 'ÚRSULA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Violet Syrup + Rice Pudding Liqueur + Black Absinthe' : 'Sirope de Violeta + Licor de Arroz con leche + Absenta Negra'}</span></p>
            </div>
            </Bounce>
            {/*
            <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#88cb6c', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>BUZZ LIGHTYEAR: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Absinthe + Rice Pudding Liqueur + Green Banana' : 'Absenta + Licor de Arroz con Leche + Plátano Verde'}</span></p>
                </div>
            </Bounce>
            */}
            <Bounce left>
            <div>
                <p className='style5Font' style={{color: '#ff6161', fontSize: 20}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'JAFAR: ' : 'JAFAR: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Falernum + Grenadine + Limoncello + Black Absinthe' : 'Falernum + Granadina + Limoncello + Absenta Negra'}</span></p>
            </div>
            </Bounce>

            <Bounce right>
                <div>
                <p className='style5Font' style={{color: '#00c750', fontSize: 20}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'DISGUST: ' : 'ASCO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Kiwi + Limoncello + Blue Absinthe + Bitters' : 'Kiwi + Limoncello + Absenta Azul + Angostura'}</span></p>
                </div>
            </Bounce>

            <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#318cfc', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1  }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'SADNESS: ' : 'TRISTEZA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Cotton Candy Liqueur + Blue Absinthe' : 'Licor de Nube + Absenta Azul'}</span></p>
                </div>
            </Bounce>

            <Bounce right>
            <div>
                <p className='style5Font' style={{color: '#763281', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span><span class="name" style={{color: '#9213cd'}}>REP</span><span class="name" style={{color: '#e5bb15'}}>UBLIC</span><span class="name" style={{color: '#e51515'}}>ANO: </span><span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Violet + Mango Liqueur + Red Absinthe' : 'Violeta + Licor de Mango + Absenta Roja'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div>
            <p className='style5Font' style={{color: '#9c2d2b', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'DEMOGORGON: ' : 'DEMOGORGON: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Licor 43 + Grenadine + Green Absinthe + Gummy' : 'Licor 43 + Granadina + Absenta Verde + Gominola'}</span></p>
            </div>
            </Bounce>
            {/*
                <Bounce left>
                <div>
                    <p className='style5Font' style={{color: '#fed10b', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>WOODY: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Mango Tequila + Chocolate + Red Absinthe' : 'Tequila de Mango + Chocolate + Absenta Roja'}</span></p>
                </div>
                </Bounce>
            */}
            {/*
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#9c2d2b', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'PENNYWISE: ' : 'PENNYWISE: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Rice Pudding Liqueur + Grenadine + Red Absinthe' : 'Licor de Arroz con Leche + Granadina + Absenta Roja'}</span></p>
            </div>
            </Bounce>
            */}
            <Bounce right>
            <div>
                <p className='style5Font' style={{color: '#ce78b9', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'CHESHIRE CAT: ' : 'GATO RISÓN: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Strawberries Tequila + Blue Absinthe' : 'Tequila de Fresa + Absenta Azul'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div>
            <p className='style5Font' style={{color: '#7f4f96', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'SKELE-GRO: ' : 'CRECEHUESOS: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Black Absinthe + Rice Pudding Liqueur' : 'Absenta Negra + Licor de Arroz con Leche'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
                <p className='style5Font' style={{color: '#3da94f', fontSize: 20 }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'KRIPTONITE: ' : 'KRIPTONITA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Green Absinthe + Melon Liqueur' : 'Absenta Verde + Licor de Melón'}</span></p>
            </div>
            </Bounce>
            {/*
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#31873f', fontSize: 20}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'HULK: ' : 'HULK: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Green Absinthe + Blueberry Liqueur' : 'Absenta Verde + Licor de Arándano'}</span></p>
            </div>
            </Bounce>
            */}
            <Bounce left>
                <div>
                <p className='style5Font' style={{color: '#b30000', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={fuego} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'ANGER: ' : 'IRA: '} <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Grenadine + Coconut Liqueur + Red Absinthe + Fire' : 'Granadina + Licor de Coco + Absenta Roja + Fuego'}</span></p>
                </div>
            </Bounce>

            <Bounce right>
            <div>
                <p className='style5Font' style={{color: '#e41b1b', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={fuego} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'TARGARYEN: ' : 'TARGARYEN: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Black Absinthe + Watermelon Liqueur + Dragon Fire' : 'Absenta Negra + Licor de Sandía + Fuego de Dragón'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div>
            <p className='style5Font' style={{color: '#ed7a45', fontSize: 20}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'JANÍS JOPLIN: ' : 'JANÍS JOPLIN: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Mandarin Liqueur + Blueberry Liqueur + Green Absinthe' : 'Licor de Mandarina + Licor de Arándano + Absenta Verde'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
                <p className='style5Font' style={{color: '#e6cc0a', fontSize: 20 }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'BARATHEON: ' : 'BARATHEON: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Banana Liqueur + Black Absinthe' : 'Licor de Plátano + Absenta Negra'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div>
            <p className='style5Font' style={{color: '#b22424', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'TRUE BLOOD: ' : 'TRUE BLOOD: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Red Absinthe + Candy Liqueur + Chupa Chups' : 'Absenta Roja + Licor de Piruleta + Chupa Chups'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
                <p className='style5Font' style={{color: '#7f1a1a', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'BLACK WIDOW: ' : 'VIUDA NEGRA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Red Absinthe + Black Vodka' : 'Absenta Roja + Vodka Negro'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div>
            <p className='style5Font' style={{color: '#3d2929', fontSize: 20}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'DARTH VADER: ' : 'DARTH VADER: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Black Absinthe + Black Vodka' : 'Absenta Negra + Vodka Negro'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
                <p className='style5Font' style={{color: '#2f69c6', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={picante} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'PROFESSOR XAVIER: ' : 'PROFESOR XAVIER: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Blue Absinthe + Honey Rum + Honey + Tabasco' : 'Absenta Azul + Ron Miel + Miel + Tabasco'}</span></p>
            </div>
            </Bounce>
            {/*
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#fe3434', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'MARCELINE: ' : 'MARCELINE: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Red Absinthe + Red Martini + Bitters' : 'Absenta Roja + Martini Rojo + Angostura'}</span></p>
            </div>
            </Bounce>
            */}
            <Bounce left>
            <div>
            <p className='style5Font' style={{color: '#2fc1c6', fontSize: 20}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'HEISENBERG: ' : 'HEISENBERG: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Limoncello + Blue Absinthe + Blue Curaçao + Peta-Zetas' : 'Limoncello + Absenta Azul + Curaçao Azul + Peta-Zetas'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
                <p className='style5Font' style={{color: '#6181ff', fontSize: 20 }}><span><img src={fuego} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'HADES: ' : 'HADES: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Blue Vodka + Blue Absinthe + Fire' : 'Vodka Azul + Absenta Azul + Fuego'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div>
            <p className='style5Font' style={{color: '#25934d', fontSize: 20}}><span><img src={fuego} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'VALYRIAN WILDFIRE: ' : 'FUEGO VALIRIO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Peppermint + Green Absinthe + Fire' : 'Peppermint + Absenta Verde + Fuego'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
                <p className='style5Font' style={{color: '#ab3a2b', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={picante} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'CHUCK NORRIS: ' : 'CHUCK NORRIS: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Red Absinthe + Bourbon + Thunderbitch + Tabasco' : 'Absenta Roja + Bourbon + Thunderbitch + Tabasco'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div>
                <p className='style5Font' style={{color: '#248f34', fontSize: 20 }}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'AVADA KEDAVRA: ' : 'AVADA KEDAVRA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Green Absinthe + Kiwi Liqueur + Black Absinthe' : 'Absenta Verde + Licor de Kiwi + Absenta Negra'}</span></p>
            </div>
            </Bounce>
            </div>
            :
            null
            }

            {/*Especiales*/}

            <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15, marginTop: 10, marginBottom: 10}}></div>

            <button onClick={()=>{this.renderChupitosIndividuales("Especiales")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
            <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
            <Zoom>
            <img src={chupitosEspeciales} style={{width: '75%', maxWidth: 350}} alt="Top"/>
            <img src={especiales} style={{width: '15%', maxWidth: 140}} alt="Top"/>
            </Zoom>
            </div>
            </button>

            {this.state.chupitosEspecialesState
            ?
            <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#e4bc4e', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span><span class="name" style={{color: '#db1414'}}>AR</span><span class="name" style={{color: '#db6e14'}}>CO</span><span class="name" style={{color: '#dbb714'}}>IR</span><span class="name" style={{color: '#10a815'}}>IS </span><span class="name" style={{color: '#007ecc'}}>4</span><span class="name" style={{color: '#ad00cc'}}>€: </span><span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Violet + Curaçao + Banana Liqueur + Passion Fruit + Red Absinthe' : 'Violeta + Curaçao + Licor de Plátano + Maracuyá + Absenta Roja'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#ec970e', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'JÄGGERBOMB 4€: ' : 'JÄGGERBOMB 4€: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Jägermeister + Red Bull' : 'Jägermeister + Red Bull'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#e4bc4e', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'DOUBLE BLOWJOB 4€: ' : 'BLOWJOB DOBLE 4€: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Coffee Liqueur + Banana Liqueur + Baileys + Whipped Cream' : 'Licor de Café + Licor de Plátano + Baileys + Nata'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#16c044', fontSize: 20}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'MINI DRY MARTINI 4€: ' : 'MINI DRY MARTINI 4€: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Gin + White Vermouth + Olive' : 'Ginebra + Vermú Blanco + Aceituna'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div>
            <p className='style5Font' style={{color: '#d463c5', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'BING BONG 4€: ' : 'BING BONG 4€: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Cotton Candy Liqueur + Strawberry Whipped Cream Liqueur + Custard Liqueur + Strawberry Macarons + Maple Syrup + Whipped Cream ' : 'Licor de Nube + Tequila de Fresa + Licor de Natillas + Macarons de Fresa + Sirope de Arce + Nata'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div>
            <p className='style5Font' style={{color: '#cd1313', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'QUEEN OF HEARTS 5€: ' : 'REINA DE CORAZONES 5€: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Red Absinthe + Strawberry + Homemade Lemonade + Lollipop' : 'Absenta Roja + Fresa + Limonada Casera + Piruleta'}</span></p>
            </div>
            </Bounce>
            </div>
            :
            null
            }

            {/*Temporada

            <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15, marginTop: 10, marginBottom: 10}}></div>

            <button onClick={()=>{this.renderChupitosIndividuales("Temporada")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
            <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
            <Zoom>
            <img src={chupitosTemporada} style={{width: '78%', maxWidth: 370}} alt="Top"/>
            <img src={temporada} style={{width: '12%', maxWidth: 120, marginRight: 5}} alt="Top"/>
            </Zoom>
            </div>
            </button>

            {this.state.chupitosTemporadaState
            ?
            <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
            <div style={{paddingBottom: 5}}>
            <Zoom>
            <div style={{}}>
            <p className='style5Font' style={{color: '#b00d07', fontSize: 20 }}>SEMANA SANTA</p>
            </div>
            </Zoom>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#b49546', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'CHUPITORRIJA: ' : 'CHUPITORRIJA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Custard Liqueur + Limoncello + Cinnamon' : 'Licor de Natillas + Limoncello + Canela'}</span></p>
            </div>
            </Bounce>
            </div>

            <div style={{paddingBottom: 5}}>
            <Zoom>
            <div style={{}}>
            <p className='style5Font' style={{color: '#b00d07', fontSize: 20 }}>DÍA DE LA HISPANIDAD</p>
            </div>
            </Zoom>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#763281', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={flipas} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span><span class="name" style={{color: '#9213cd'}}>REP</span><span class="name" style={{color: '#e5bb15'}}>UBLIC</span><span class="name" style={{color: '#e51515'}}>ANO: </span><span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Violet + Mango Liqueur + Red Absinthe' : 'Violeta + Licor de Mango + Absenta Roja'}</span></p>
            </div>
            </Bounce>
            </div>

            <div style={{paddingBottom: 5}}>
            <Zoom>
            <div style={{}}>
            <p className='style5Font' style={{color: '#b00d07', fontSize: 20 }}>HALLOWEEN</p>
            </div>
            </Zoom>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#dcbf2e', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'TREAK: ' : 'TRUCO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Chocolate + Vodka + Mandarine Liqueur + Egg Liqueur + Whipped Cream' : 'Chocolate + Vodka + Licor de Mandarina + Licor de Huevo + Nata'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div style={{}}>
                <p className='style5Font' style={{color: '#9e502e', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'TREAT: ' : 'TRATO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Chocolate + Hazelnut Liqueur + Caramel Vodka + White Chocolate Liqueur + Whipped Cream' : 'Chocolate + Licor de Avellana + Vodka Caramelo + Licor de Chocolate Blanco + Nata'}</span></p>
            </div>
            </Bounce>
            </div>

            <div style={{paddingBottom: 5}}>
            <Zoom>
            <div style={{}}>
            <p className='style5Font' style={{color: '#b00d07', fontSize: 20 }}>ACCIÓN DE GRACIAS</p>
            </div>
            </Zoom>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#e4bc4e', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'APPLE PIE: ' : 'APPLE PIE: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'ThunderBitch + Apple Juice + Whipped Cream + Cinnamon' : 'Thunderbitch + Zumo de Manzana + Nata + Canela'}</span></p>
            </div>
            </Bounce>
            </div>

            <div style={{paddingBottom: 5}}>
            <Zoom>
            <div style={{}}>
            <p className='style5Font' style={{color: '#b00d07', fontSize: 20 }}>NAVIDAD (Tabla 10€)</p>
            </div>
            </Zoom>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#bd8a14', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'ROSCONCITO: ' : 'ROSCONCITO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Mandarine Liqueur + Triple Sec + Orange Blossom Water + Sugar + Whipped Cream' : 'Licor de Mandarina + Triple Seco + Agua de Azar + Azúcar + Nata'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div style={{}}>
                <p className='style5Font' style={{color: '#294e08', fontSize: 20 }}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'AFTER EIGHT: ' : 'AFTER EIGHT: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka +Chocolate Syrup + Peppermint' : 'Vodka + Sirope de Chocolate + Peppermint'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#d3bb5a', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'CHUPOLVORON: ' : 'CHUPOLVORON: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Orujo Cream + Almond Liqueur + Sugar' : 'Crema de Orujo + Licor de Almendra + Azúcar Glas'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div style={{}}>
                <p className='style5Font' style={{color: '#cd7e42', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={fuertes} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'PONCHITO DE HUEVO: ' : 'PONCHITO DE HUEVO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vanilla Syrup + Cinamon Liqueur + Egg Liqueur' : 'Sirope de Vainilla + Licor de Canela+ Licor ponche de huevo'}</span></p>
            </div>
            </Bounce>
            <Bounce left>
            <div style={{}}>
                <p className='style5Font' style={{color: '#dcbf2e', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'CHUPITURRÓN: ' : 'CHUPITURRÓN: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Ron + Almond Liqueur + Honey' : 'Ron + Licor de Almendras + Miel'}</span></p>
            </div>
            </Bounce>
            <Bounce right>
            <div style={{}}>
                <p className='style5Font' style={{color: '#9e502e', fontSize: 20 }}><span><img src={suaves} style={{height: 25, marginRight: 5, marginBottom: -5}} alt="Top"/></span>{this.state.languageEnglish ? 'FERRERO: ' : 'FERRERO: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Chocolate Syrup + Hazelnut Syrup + Hazelnut' : 'Vodka + Sirope de Chocolate + Licor de Avellana + Avellanas'}</span></p>
            </div>
            </Bounce>
            </div>

            </div>
            :
            null
            }
            */}

            </div>
            
                )
            
            }







            renderBebidas(){
                return(
                    <div id="bebidas" style={{display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', marginTop: 20}}>
                    <div style={{width: '90%', height: 2, backgroundColor: '#CF1009'}}></div>
                    <Fade bottom>
                    <p className='style10Font' style={{fontSize: 40, color: '#b00d07', textAlign: 'center', marginBottom: 30}}>{this.state.languageEnglish ? 'COCKTAILS & DRINKS' : 'COCKTAILS Y BEBIDAS'}</p>
                    </Fade>
        
                    <Fade bottom>
                    <div style={{display: 'flex', flexDirection: 'column', width: '90%', alignItems: 'center', justifyContent: 'center'}}>
                    <img src={bebidas} style={{width: '35%', maxWidth: 150}} alt="Top"/>
                    <p className='style9Font' style={{fontSize: 22, fontWeight: 'bold', color: 'black', textAlign: 'center', marginTop: 10}}>{this.state.languageEnglish ? 'The best cocktails and drinks are here! Don’t you dare leave a single drop left in your glass!' : 'Los mejores cocktails y bebidas están aquí, no dejarás ni una gota en el vaso'}</p>
                    </div>
                    
                    </Fade>
        
                    

                    {/*Cocktails*/}
                    

                    <div style={{display: 'flex', width: '95%', alignItems: 'center', justifyContent: 'flex-start', marginTop: 20, marginBottom: 40}}>
                    <Zoom>
                    <img src={cocktailIcono} style={{width: '15%', maxWidth: 140}} alt="Top"/>
                    <p className='style10Font' style={{fontSize: 25, color: '#b00d07', textAlign: 'center', marginTop: 0, marginBottom: 0}}>{this.state.languageEnglish ? 'COCKTAILS' : 'COCKTAILS'}</p>
                    </Zoom>
                    </div>

                    {/*Tropicales*/}
        
                    <button onClick={()=>{this.renderCocktails("tropicales")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                        <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                        <Zoom>
                        <img src={tropicales} style={{width: '50%', maxWidth: 250}} alt="Top"/>
                        <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 35, textAlign: 'center', marginTop: 0, marginBottom: 0}}>11 €</p>
                        </Zoom>
                        </div>
                        </button>
        
                        {this.state.cocktailsTropicales
                        ?
                        <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                        <Bounce left>
                        <div style={{}}>
                            <p className='style5Font' style={{color: '#419e2e', fontSize: 20 }}>{'MOJITO:'}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'White Rum + Sprite + Lime Juice + Peppermint + Sugar + Bitters' : 'Ron Blanco + Sprite + Zumo de Lima + Hierbabuena + Azúcar + Angostura'}</span></p>
                        </div>
                        </Bounce>
                        <Bounce right>
                        <div>
                        <p className='style5Font' style={{color: '#e37226', fontSize: 20}}>{'SEX ON THE BEACH:'} <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Blueberry Juice + Orange Juice + Peach Juice' : 'Vodka + Licor de Melocotón + Zumo de Naranja + Zumo de Arándanos'}</span></p>
                        </div>
                        </Bounce>
                        <Bounce left>
                        <div>
                            <p className='style5Font' style={{color: '#d4ba35', fontSize: 20 }}>{'PIÑA COLADA:'} <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'White Rum + Coconut Syrup + Pineapple Syrup + Pineapple Juice' : 'Ron Blanco + Sirope de Coco + Sirope de Piña + Zumo de Piña'}</span></p>
                        </div>
                        </Bounce>
                        <Bounce right>
                        <div>
                        <p className='style5Font' style={{color: '#35b7d4', fontSize: 20}}>BLUE LAGOON: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Homemade Lemonade + Blue Curaçao' : 'Vodka + Limonada Casera + Curaçao Azul'}</span></p>
                        </div>
                        </Bounce>
                        </div>
                        :
                        null
                        }
        
                    {/*Tropicales Premium*/}
        
                    <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15, marginTop: 10, marginBottom: 10}}></div>
        
                    <button onClick={()=>{this.renderCocktails("tropicalesPremium")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                    <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                        <Zoom>
                        <img src={tropicalesPrem} style={{width: '75%', maxWidth: 350}} alt="Top"/>
                        <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 35, textAlign: 'center', marginTop: 0, marginBottom: 0}}>12 €</p>
                        </Zoom>
                        </div>
                    </button>
        
                    {this.state.cocktailsTropicalesPremium
                    ?
                    <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                        <Bounce left>
                        <div style={{}}>
                            <p className='style5Font' style={{color: '#d4358d', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}>PINK CARIBBEAN: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'White Rum + Coconut Liquor + Coconut Syrup + Pineapple Juice + Grenadine + Lime' : 'Ron Blanco + Licor de Coco + Sirope de Coco + Zumo de Piña + Granadina + Lima'}</span></p>
                        </div>
                        </Bounce>
                        <Bounce right>
                        <div>
                        <p className='style5Font' style={{color: '#d43550', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1}}>{this.state.languageEnglish ? 'STRAWBERRY MOJITO: ' : 'MOJITO DE FRESA: '}<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'White Rum + Sprite + Lime Juice + Strawberry Syrup + Peppermint + Sugar + Bitters' : 'Ron Blanco + Sprite + Zumo de Lima + Sirope de Fresa + Hierbabuena + Azúcar + Angostura'}</span></p>
                        </div>
                        </Bounce>
                        <Bounce left>
                        <div>
                            <p className='style5Font' style={{color: '#dac54e', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}>DAIQUIRI: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'White Rum + Triple Sec + Lime Juice + Sugar' : 'Ron Blanco + Triple Seco + Zumo de Lima + Azúcar'}</span></p>
                        </div>
 
                        </Bounce>
                        <Bounce right> 
                        <div>
                        <p className='style5Font' style={{color: '#c14e4e', fontSize: 20}}>{this.state.languageEnglish ? 'STRAWBERRY DAIQUIRI (+1€): ' : 'DAIQUIRI DE FRESA (+1€): ' }<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'White Rum + Strawberry Liqueur + Lime Juice + Strawberry Puree' : 'Ron Blanco + Licor de Fresas + Zumo de Lima + Puré de fresas'}</span></p>
                        </div>
                        </Bounce>
                        <Bounce left> 
                        <div>
                        <p className='style5Font' style={{color: '#f39320', fontSize: 20}}>{this.state.languageEnglish ? 'PASSION FRUIT & MARACUYÁ DAIQUIRI (+1€): ' : 'DAIQUIRI MANGO Y MARACUYÁ (+1€): ' }<span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'White Rum + Passion Fruit Liqueur + Lime Juice + Passion Fruit Puree + Maracuyá Syrup' : 'Ron Blanco + Licor de Mango + Zumo de Lima + Puré de Mango + Sirope de Maracuyá'}</span></p>
                        </div>
                        </Bounce>
                        <Bounce right>
                        <div>
                            <p className='style5Font' style={{color: '#229720', fontSize: 20 }}>CAIPIRINHA: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Cachaça + Lime + Sugar' : 'Cachaça + Lima + Azúcar'}</span></p>
                        </div>
                        </Bounce>
                        <Bounce left>
                        <div>
                        <p className='style5Font' style={{color: '#93ba26', fontSize: 20}}>CAIPIROSKA: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Lime + Sugar' : 'Vodka + Lima + Azúcar'}</span></p>
                        </div>
                        </Bounce>
                        <Bounce right>
                        <div>
                            <p className='style5Font' style={{color: '#f39316', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}>TEQUILA SUNRISE: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Tequila + Orange Juice + Grenadine' : 'Tequila + Zumo de Naranja + Granadina'}</span></p>
                        </div>
                        </Bounce>
                        <Bounce left>
                        <div>
                        <p className='style5Font' style={{color: '#e9cb0c', fontSize: 20}}>MARGARITA: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Tequila + Triple Sec + Lime + Sugar + Salt' : 'Tequila + Triple Seco + Lima + Azúcar + Sal'}</span></p>
                        </div>
                        </Bounce>
                        <Bounce right>
                        <div>
                        <p className='style5Font' style={{color: '#93ba14', fontSize: 20}}>{'SPICY MARGARITA (+1€):'} <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Tequila + Triple Sec + Lime + Sugar + Jalapeno' : 'Tequila + Triple Seco + Lima + Azúcar + Jalapeño'}</span></p>
                        </div>
                        </Bounce>
                        <Bounce left>
                        <div>
                        <p className='style5Font' style={{color: '#bc0187', fontSize: 20}}> COCKTAIL PIPAZO: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Peach Liqueur + Coconut Syrup + Limonade + Violet' : 'Vodka + Licor de Melocotón + Sirope de Coco + Limonada + Violeta'}</span></p>
                        </div>
                        </Bounce>
                        <Bounce left>
                        <div>
                        <p className='style5Font' style={{color: '#a77e01', fontSize: 20}}> VENENO DE IGGY: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Spiced Rum + Coconut + Pineapple Juice + Coffee Shot' : 'Ron Especiado + Coco + Zumo de Piña + Shot de Café'}</span></p>
                        </div>
                        </Bounce>
                    </div>
                    :
                    null
                    }
        
                    {/*Clásicos*/}
        
                    <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15, marginTop: 10, marginBottom: 10}}></div>
        
                    <button onClick={()=>{this.renderCocktails("clasicos")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                    <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                        <Zoom>
                        <img src={clasicos} style={{width: '45%', maxWidth: 230}} alt="Top"/>
                        <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 35, textAlign: 'center', marginTop: 0, marginBottom: 0}}>12 €</p>
                        </Zoom>
                        </div>
                    </button>
        
                    {this.state.cocktailsClasicos
                    ?
                    <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                    <Bounce left>
                    <div>
                        <p className='style5Font' style={{color: '#d00b0b', fontSize: 20 }}>COSMOPOLITAN: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Triple Sec + Lime Juice + Blueberry Juice + Orange Liqueur' : 'Vodka + Triple Seco + Zumo de Lima + Zumo de Arándanos + Naranja Flameada'}</span></p>
                    </div>
                    </Bounce>
                    <Bounce right>
                    <div>
                    <p className='style5Font' style={{color: '#916808', fontSize: 20}}>BLACK RUSSIAN: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Coffee Liqueur' : 'Vodka + Licor de Café'}</span></p>
                    </div>
                    </Bounce>
                    <Bounce left>
                    <div>
                    <p className='style5Font' style={{color: '#ac9a72', fontSize: 20 }}>WHITE RUSSIAN: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Coffee Liqueur + Milk' : 'Vodka + Licor de Café + Leche'}</span></p>
                    </div>
                    </Bounce>
                    <Bounce right>
                    <div>
                    <p className='style5Font' style={{color: '#e62d2d', fontSize: 20}}>BLOODY MARY: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Tomato Juice + Lemon + Salt + Pepper + Worcestershire Sauce + Tabasco' : 'Vodka + Zumo de Tomate + Limón + Sal + Pimienta + Salsa Perrins + Tabasco'}</span></p>
                    </div>
                    </Bounce>
                    <Bounce left>
                    <div>
                    <p className='style5Font' style={{color: '#625c50', fontSize: 20 }}>LECHE DE PANTERA: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Gin + Condensed Milk + Cinnamon' : 'Ginebra + Leche Condensada + Canela'}</span></p>
                    </div>
                    </Bounce>
                    <Bounce right>
                    <div>
                    <p className='style5Font' style={{color: '#977d3f', fontSize: 20 }}>DARK AND STORMY: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Rum + Ginger Ale + Lime Juice + Bitters' : 'Ron Añejo + Ginger Ale + Zumo de Lima + Angostura'}</span></p>
                    </div>
                    </Bounce>
                    </div>
                    :
                    null
                    }

                    {/*Clásicos Premium*/}
        
                    <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15, marginTop: 10, marginBottom: 10}}></div>
        
                    <button onClick={()=>{this.renderCocktails("clasicosPremium")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                    <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                        <Zoom>
                        <img src={clasicosPremium} style={{width: '70%', maxWidth: 350}} alt="Top"/>
                        <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 35, textAlign: 'center', marginTop: 0, marginBottom: 0}}>14 €</p>
                        </Zoom>
                        </div>
                    </button>
        
                    {this.state.cocktailsClasicosPremium
                    ?
                    <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                    <Bounce left>
                    <div>
                    <p className='style5Font' style={{color: '#ecb939', fontSize: 20 }}>GIN ALEXANDRE: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Gin + Coconut Liqueur + Milk' : 'Ginebra + Licor de Coco + Leche'}</span></p>
                    </div>
                    </Bounce>
                    <Bounce right>
                    <div>
                    <p className='style5Font' style={{color: '#9b9e67', fontSize: 20}}>DRY MARTINI: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Gin + White Vermouth + Olives' : 'Ginebra + Vermú Blanco + Aceitunas'}</span></p>
                    </div>
                    </Bounce>
                    <Bounce left>
                    <div>
                    <p className='style5Font' style={{color: '#75371a', fontSize: 20}}>ESPRESSO MARTINI: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka + Coffee Liqueur + Coffee + Sugar' : 'Vodka + Licor de Café + Café + Azúcar'}</span></p>
                    </div>
                    </Bounce>
                    <Bounce right>
                    <div>
                    <p className='style5Font' style={{color: '#b54f4f', fontSize: 20 }}>MANHATAN: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Bourbon + Red Vermouth + Bitters' : 'Bourbon + Vermú Rojo + Angostura'}</span></p>
                    </div>
                    </Bounce>
                    <Bounce left>
                    <div>
                    <p className='style5Font' style={{color: '#9b8e47', fontSize: 20}}>NEGRONI: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Campari + Gin + Vermu Wine + Orange Juice' : 'Campari + Ginebra + Vermú Rojo + Zumo de Naranja'}</span></p>
                    </div>
                    </Bounce>
                    </div>
                    :
                    null
                    }

                    {/*Sin Alcohol*/}
        
                    <div style={{width: '90%', height: 2, backgroundColor: 'black', opacity: 0.15, marginTop: 10, marginBottom: 10}}></div>
        
                    <button onClick={()=>{this.renderCocktails("sinAlcohol")}} style={{width: '95%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', background: 'none'}}>
                    <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                        <Zoom>
                        <img src={sinAlcohol} style={{width: '60%', maxWidth: 300}} alt="Top"/>
                        <p className='style9Font' style={{fontWeight: 'bold', color: 'black', fontSize: 35, textAlign: 'center', marginTop: 0, marginBottom: 0}}>10 €</p>
                        </Zoom>
                        </div>
                    </button>
        
                    {this.state.cocktailsSinAlcohol
                    ?
                    <div style={{width: '95%', margin: 'auto', margin: 20, marginTop: 0}}>
                    <Bounce left>
                    <div>
                    <p className='style5Font' style={{color: '#d8a22c', fontSize: 20, opacity: this.state.venganFilter ? 0.15 : 1 }}>SAN FRANCISCO: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Orange Juice + Peach Juice + Pineapple Juice + Grenadine' : 'Zumo de Naranja + Zumo de Melocotón + Zumo de Piña + Granadina'}</span></p>
                    </div>
                    </Bounce>
                    <Bounce right>
                    <div>
                    <p className='style5Font' style={{color: '#ddcb46', fontSize: 20}}>PIÑA COLADA VIRGEN: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Coconut Syrup + Pineapple Syrup + Pineapple Juice' : 'Sirope de Coco + Sirope de Piña + Zumo de Piña'}</span></p>
                    </div>
                    </Bounce>
                    <Bounce left>
                    <div>
                    <p className='style5Font' style={{color: '#21931b', fontSize: 20 }}>MOJITO VIRGEN: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Sprite + Lime Juice + Peppermint + Sugar' : 'Sprite + Zumo de Lima + Hierbabuena + Azúcar'}</span></p>
                    </div>
                    </Bounce>
                    <Bounce right>
                    <div>
                    <p className='style5Font' style={{color: '#c22424', fontSize: 20}}>SAINT BLOODY MARY: <span className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Tomato Juice + Lemon Juice + Pepper + Salt + Warcestershire Sauce + Tabasco' : 'Zumo de Tomate + Zumo de Limón + Pimienta + Sal + Salsa Perrins + Tabasco'}</span></p>
                    </div>
                    </Bounce>
                    </div>
                    :
                    null
                    }



                    {/*Cervezas*/}

                    <div style={{display: 'flex', width: '95%', alignItems: 'center', justifyContent: 'flex-start', marginTop: 50, marginBottom: 20}}>
                    <Zoom>
                    <img src={cervezaIcono} style={{width: '15%', maxWidth: 140, marginRight: 5}} alt="Top"/>
                    <p className='style10Font' style={{fontSize: 25, color: '#b00d07', textAlign: 'center', marginTop: 5, marginBottom: 0}}>{this.state.languageEnglish ? 'BEERS' : 'CERVEZAS'}</p>
                    </Zoom>
                    </div>

                    <div style={{width: '90%'}}>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Estrella Galicia Small' : 'Caña Estrella Galicia'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>4 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Estrella Galicia Pint' : 'Jarra Estrella Galicia'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>6 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <img src={palmeraIcono} style={{width: '15%', maxWidth: 150, marginRight: 5}} alt="Top"/>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'BirraColau Small' : 'BirraColau Caña'}</p>
                    <p className='style9Font' style={{color: 'green', fontSize: 14, fontWeight: 'bold', paddingLeft: 5}}>{'(Summer Edition)'}</p>
                    </div>
                    
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <img src={palmeraIcono} style={{width: '15%', maxWidth: 150, marginRight: 5}} alt="Top"/>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'DaiBirri Small' : 'DaiBirri Caña'}</p>
                    <p className='style9Font' style={{color: 'green', fontSize: 14, fontWeight: 'bold', paddingLeft: 5}}>{'(Summer Edition)'}</p>
                    </div>
                    
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <img src={palmeraIcono} style={{width: '15%', maxWidth: 150, marginRight: 5}} alt="Top"/>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'BirraColau Pint' : 'BirraColau Jarra'}</p>
                    <p className='style9Font' style={{color: 'green', fontSize: 14, fontWeight: 'bold', paddingLeft: 5}}>{'(Summer Edition)'}</p>
                    </div>
                    
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>6,5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <img src={palmeraIcono} style={{width: '15%', maxWidth: 150, marginRight: 5}} alt="Top"/>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'DaiBirri Pint' : 'DaiBirri Jarra'}</p>
                    <p className='style9Font' style={{color: 'green', fontSize: 14, fontWeight: 'bold', paddingLeft: 5}}>{'(Summer Edition)'}</p>
                    </div>
                    
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>6,5 €</p>
                    </div>
                    </Zoom>


                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Cider' : 'Sidra Cider'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>4 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Syrup Beer' : 'Caña con sirope'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>4,5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Syrup Pint' : 'Jarra con sirope'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>6,5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Estrella Galicia 33 cl' : 'Tercio Estrella Galicia'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>4 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Estrella Galicia Gluten Free 33 cl' : 'Tercio Estrella Galicia sin Gluten'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>4 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? '1906 Red Vintage' : '1906 Red Vintage'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>4,5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Coronita' : 'Coronita'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>4,5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Desperados' : 'Desperados'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>4,5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Paulaner' : 'Paulaner'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>5,5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Guinness' : 'Cerveza Negra'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Craft Beer' : 'Cerveza Artesana'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>5 €</p>
                    </div>
                    </Zoom>

                    </div>

                    {/*Refrescos*/}

                    <div style={{display: 'flex', width: '95%', alignItems: 'center', justifyContent: 'flex-start', marginTop: 30, marginBottom: 20}}>
                    <Zoom>
                    <img src={refrescosIcono} style={{width: '15%', maxWidth: 140, marginRight: 5}} alt="Top"/>
                    <p className='style10Font' style={{fontSize: 25, color: '#b00d07', textAlign: 'center', marginTop: 5, marginBottom: 0}}>{this.state.languageEnglish ? 'SODAS' : 'REFRESCOS'}</p>
                    </Zoom>
                    </div>

                    <div style={{width: '90%'}}>
                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Coca-Cola, Fanta, Sprite or Tonic' : 'Coca-Cola, Fanta, Sprite o Tónica'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>3,5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Aquarius or Nestea' : 'Aquarius o Nestea'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>3,5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Red Bull' : 'Red Bull'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>4 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Water' : 'Agua'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>2 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Sparkling Water' : 'Agua con Gas'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>3,5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Juice (Orange, Pineapple, Peach or Tomato)' : 'Zumo de Naranja, Piña, Meloc. o Tomate'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>3,5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Natural Orange Juice' : 'Zumo de Naranja Natural'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Ginger Ale' : 'Ginger Ale'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>4 €</p>
                    </div>
                    </Zoom>

                    
                    </div>

                    {/*Vinos*/}

                    <div style={{display: 'flex', width: '95%', alignItems: 'center', justifyContent: 'flex-start', marginTop: 30, marginBottom: 20}}>
                    <Zoom>
                    <img src={vinosIcono} style={{width: '15%', maxWidth: 140, marginRight: 5}} alt="Top"/>
                    <p className='style10Font' style={{fontSize: 25, color: '#b00d07', textAlign: 'center', marginTop: 5, marginBottom: 0}}>{this.state.languageEnglish ? 'WINES' : 'VINOS'}</p>
                    </Zoom>
                    </div>

                    <div style={{width: '90%'}}>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'White Wine Rueda Verdejo' : 'Vino Blanco Rueda Verdejo'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>4 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Red Wine Rioja Crianza' : 'Vino Tinto Rioja Crianza'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>4 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Tinto de Verano 0,5L' : 'Tinto de Verano 0,5L'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>4,5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vermut' : 'Vermut'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>4,5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>


                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Sangría Jar 0,5L' : 'Jarra Sangría 0,5L'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>5,5 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Red Wine with Cola' : 'Kalimotxo'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>4,5 €</p>
                    </div>
                    </Zoom>

                    </div>



                    {/*Batidos*/}

                    <div style={{display: 'flex', width: '95%', alignItems: 'center', justifyContent: 'flex-start', marginTop: 30, marginBottom: 20}}>
                    <Zoom>
                    <img src={batidoIcono} style={{width: '15%', maxWidth: 140, marginRight: 5}} alt="Top"/>
                    <p className='style10Font' style={{fontSize: 25, color: '#b00d07', textAlign: 'center', marginTop: 5, marginBottom: 0}}>{this.state.languageEnglish ? 'MilkShakes' : 'Batidos'}</p>
                    </Zoom>
                    </div>

                    <div style={{width: '90%'}}>
                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Strawberry Milkshake' : 'Batido de Fresa'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>8 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Lemon MilkShake' : 'Batido de Limon'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>8 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Oreo MilkShake' : 'Batido de Oreo'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>8 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Chips Ahoy MilkShake' : 'Batido de Chips Ahoy'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5, whiteSpace: 'nowrap'}}>8 €</p>
                    </div>
                    </Zoom>
                    </div>


                    {/*Copas*/}

                    <div style={{display: 'flex', width: '95%', alignItems: 'center', justifyContent: 'flex-start', marginTop: 30, marginBottom: 20}}>
                    <Zoom>
                    <img src={copasIcono} style={{width: '15%', maxWidth: 140, marginRight: 5}} alt="Top"/>
                    <p className='style10Font' style={{fontSize: 25, color: '#b00d07', textAlign: 'center', marginTop: 5, marginBottom: 0}}>{this.state.languageEnglish ? 'Copas' : 'Copas'}</p>
                    </Zoom>
                    </div>

                    <div style={{width: '90%'}}>
                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Whiskey (Ballantines, White Label, Cutty Sark, Johnnie Walker, JB, Jim Beam)' : 'Whiskey (Ballantines, White Label, Cutty Sark, Johnnie Walker, JB, Jim Beam)'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>9 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Whiskey Jack Daniel´s' : 'Whiskey Jack Daniel´s'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>11 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Rum (Arahuecas, Cacique, Brugal, Barceló, Legendario)' : 'Ron (Arahuecas, Cacique, Brugal, Barceló, Legendario)'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>9 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Rum Havana Club 7 years' : 'Ron Havana Club 7 años'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>11 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Gin (Larios 12, Beefeater, Seagram´s, Tanqueray, Strawberry Puerto de Indias)' : 'Ginebra (Larios 12, Beefeater, Seagram´s, Tanqueray, Puerto de Indias de Fresa)'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>9 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Gin (Bombay Sapphire, Hendrick´s, Bulldog)' : 'Ginebra (Bombay Saphire, Hendrick´s, Bulldog)'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>11 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Gin Brockman´s (with Strawberry)' : 'Ginebra Brockman´s (con Fresa)'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>13 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Vodka (Absolut, Eristoff, Smirnoff)' : 'Vodka (Absolut, Eristoff, Smirnoff)'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>9 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'On the Rocks' : 'On the Rocks (Cualquier licor solo con hielo)'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>8 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'On The Rocks Premium (Jack Daniel´s, Hendricks, Havana Club 7 years, Bombay Saphie, Bulldog)' : 'On The Rocks Premium (Jack Daniel´s, Hendricks, Havana Club 7 años, Bombay Saphie, Bulldog)'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>10 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Cocktail Shot' : 'Chupito en Copa'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>10 €</p>
                    </div>
                    </Zoom>
                    </div>

                    {/*Suplementos*/}

                    <div style={{display: 'flex', width: '95%', alignItems: 'center', justifyContent: 'flex-start', marginTop: 30, marginBottom: 20}}>
                    <Zoom>
                    <img src={extrasIcono} style={{width: '15%', maxWidth: 140, marginRight: 5}} alt="Top"/>
                    <p className='style10Font' style={{fontSize: 25, color: '#b00d07', textAlign: 'center', marginTop: 5, marginBottom: 0}}>{this.state.languageEnglish ? 'Extras' : 'Suplementos'}</p>
                    </Zoom>
                    </div>

                    <div style={{width: '90%'}}>
                   

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Surcharge Ginger Ale or Blueberry' : 'Suplemento Ginger Ale o Arándanos'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>+1 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Surcharge Red Bull' : 'Suplemento Bebida energética'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>+1 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Extra alcohol in your drink' : 'Extra de Alcohol en la Bebida'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>+2 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Surcharge Oranje Juice' : 'Suplemento Zumo de Naranja'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>+2 €</p>
                    </div>
                    </Zoom>

                    
                    </div>


                    </div>
                    )
            }

            renderSnacks(){
                return(
                    <div id="snacks" style={{display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', marginTop: 20}}>
                    <div style={{width: '90%', height: 2, backgroundColor: '#CF1009'}}></div>
                    <Fade bottom>
                    <p className='style10Font' style={{fontSize: 40, color: '#b00d07', textAlign: 'center', marginBottom: 30}}>{this.state.languageEnglish ? 'SNACKS' : 'SNACKS'}</p>
                    </Fade>
        
                    <Fade bottom>
                    <div style={{display: 'flex', flexDirection: 'column', width: '90%', alignItems: 'center', justifyContent: 'center'}}>
                    <img src={snacks} style={{width: '35%', maxWidth: 150}} alt="Top"/>
                    <p className='style9Font' style={{fontSize: 22, fontWeight: 'bold', color: 'black', textAlign: 'center', marginTop: 10}}>{this.state.languageEnglish ? 'Whether they’re salty or sweet, don’t let these snacks pass you by!' : 'Ya seas de dulce o salado, nuestros aperitivos no pasan desapercibidos'}</p>
                    </div>
                    
                    </Fade>

                    <div style={{display: 'flex', width: '95%', alignItems: 'center', justifyContent: 'flex-start', marginTop: 30, marginBottom: 20}}>
                    <Zoom>
                    <img src={snackDulce} style={{width: '15%', maxWidth: 140, marginRight: 5}} alt="Top"/>
                    <p className='style10Font' style={{fontSize: 25, color: '#b00d07', textAlign: 'center', marginTop: 5, marginBottom: 0}}>{this.state.languageEnglish ? 'Sweet Snacks' : 'Snacks Dulces'}</p>
                    </Zoom>
                    </div>

                    <div style={{width: '90%'}}>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Chocolate Bar' : 'Barrita Huesitos'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>1 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Bag of Sweets' : 'Bolsa de Chuches'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>1 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Bowl of Gummies' : 'Bol de Gominolas'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>2 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Bowl of Mini Oreos' : 'Bol de Mini Oreos'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>2 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Bowl of Mini Chips Ahoy' : 'Bol de Mini Chips Ahoy'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>2 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Chocolate Candies' : 'Bote de Lacasitos'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>2 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Kinder Joy' : 'Kinder Joy'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>2 €</p>
                    </div>
                    </Zoom>



                    </div>


                    <div style={{display: 'flex', width: '95%', alignItems: 'center', justifyContent: 'flex-start', marginTop: 30, marginBottom: 20}}>
                    <Zoom>
                    <img src={snackSalado} style={{width: '15%', maxWidth: 140, marginRight: 5}} alt="Top"/>
                    <p className='style10Font' style={{fontSize: 25, color: '#b00d07', textAlign: 'center', marginTop: 5, marginBottom: 0}}>{this.state.languageEnglish ? 'Savory Snacks' : 'Snacks Salados'}</p>
                    </Zoom>
                    </div>

                    <div style={{width: '90%'}}>
                        
                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Bowl of Olives' : 'Bol de Aceitunas'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>2 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 40}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Chips (Small Bag)' : 'Bolsa de Patatas Fritas'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>2 €</p>
                    </div>
                    </Zoom>

                    {/*

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Hand Made Hummus' : 'Hummus Casero'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>6 €</p>
                    </div>
                    </Zoom>

                    <div style={{width: '100%', height: 2, backgroundColor: 'black', opacity: 0.15}}></div>

                    <Zoom>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', paddingRight: 5}}>{this.state.languageEnglish ? 'Nachos with Cheese or Mexican Sauce' : 'Nachos con salsa de Queso o Mexicana'}</p>
                    <p className='style9Font' style={{color: 'black', fontSize: 18, fontWeight: 'bold', whiteSpace: 'nowrap'}}>5 €</p>
                    </div>
                    </Zoom>
                    */}

                    </div>
        


                    </div>
                    )
            }

    render(){

        return(
        <div>
            {this.renderCover()}
        </div>
        )
    }
}

export default Carta;